import React from "react";

interface IconProps {
  className?: string;
  size?: number;
  color?: string;
}

export const AdMobIcon: React.FC<IconProps> = ({ className = "" }) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
      fill="#4285F4"
    />
    <path
      d="M12 6c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6zm0 10c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4z"
      fill="#4285F4"
    />
  </svg>
);

export const GoogleAdsIcon: React.FC<IconProps> = ({ className = "" }) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
      fill="#4285F4"
    />
    <path
      d="M12 6c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6zm0 10c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4z"
      fill="#4285F4"
    />
    <path
      d="M12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"
      fill="#4285F4"
    />
  </svg>
);

export const RippleIcon: React.FC<IconProps> = ({
  className = "",
  size = 24,
  color = "currentColor",
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <circle cx="50" cy="50" r="45" stroke={color} strokeWidth="7" />
      <circle cx="50" cy="50" r="32" stroke={color} strokeWidth="7" />
      <circle cx="50" cy="50" r="19" stroke={color} strokeWidth="7" />
      <circle cx="50" cy="50" r="6" stroke={color} strokeWidth="7" />
    </svg>
  );
};

export const UniversalGlobe: React.FC<IconProps> = ({
  className = "",
  size = 24,
  color = "#00A3FF",
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 600 600"
      fill={"none"}
      className={className}
    >
      <path
        d="M300 550C439.787 550 550 439.787 550 300C550 160.213 439.787 50 300 50C160.213 50 50 160.213 50 300C50 439.787 160.213 550 300 550Z"
        fill="#ffffff"
        stroke={color}
        strokeWidth="40"
      />
      <path
        d="M300 50C380 120 420 200 420 300C420 400 380 480 300 550C220 480 180 400 180 300C180 200 220 120 300 50Z"
        fill={color}
        fillOpacity="0.3"
      />
      <path
        d="M50 300H550M180 300C180 200 220 120 300 50C380 120 420 200 420 300C420 400 380 480 300 550C220 480 180 400 180 300Z"
        stroke={color}
        strokeWidth="40"
      />
    </svg>
  );
};

export const GoogleIcon: React.FC<IconProps> = ({
  className = "",
  size = 24,
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="-3 0 262 262"
      preserveAspectRatio="xMidYMid"
      className={className}
    >
      <path
        d="M255.878 133.451c0-10.734-.871-18.567-2.756-26.69H130.55v48.448h71.947c-1.45 12.04-9.283 30.172-26.69 42.356l-.244 1.622 38.755 30.023 2.685.268c24.659-22.774 38.875-56.282 38.875-96.027"
        fill="#4285F4"
      />
      <path
        d="M130.55 261.1c35.248 0 64.839-11.605 86.453-31.622l-41.196-31.913c-11.024 7.688-25.82 13.055-45.257 13.055-34.523 0-63.824-22.773-74.269-54.25l-1.531.13-40.298 31.187-.527 1.465C35.393 231.798 79.49 261.1 130.55 261.1"
        fill="#34A853"
      />
      <path
        d="M56.281 156.37c-2.756-8.123-4.351-16.827-4.351-25.82 0-8.994 1.595-17.697 4.206-25.82l-.073-1.73L15.26 71.312l-1.335.635C5.077 89.644 0 109.517 0 130.55s5.077 40.905 13.925 58.602l42.356-32.782"
        fill="#FBBC05"
      />
      <path
        d="M130.55 50.479c24.514 0 41.05 10.589 50.479 19.438l36.844-35.974C195.245 12.91 165.798 0 130.55 0 79.49 0 35.393 29.301 13.925 71.947l42.211 32.783c10.59-31.477 39.891-54.251 74.414-54.251"
        fill="#EB4335"
      />
    </svg>
  );
};

export const BrowserChrome: React.FC<IconProps> = ({
  className = "",
  size = 24,
}) => {
  return (
    <svg width={size} height={size} viewBox="0 0 14 14" className={className}>
      <defs>
        <linearGradient
          id="a"
          x1="127.4696"
          x2="127.4696"
          y1="82.259239"
          y2="173.66644"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0%" stopColor="#86BBE5" />
          <stop offset="100%" stopColor="#1072BA" />
        </linearGradient>
      </defs>
      <path
        fill="#ef3f36"
        d="M6.98477663 1.00106312s3.52400739-.15814053 5.39235825 3.38402026H6.68491785S5.61068512 4.3504609 4.69304895 5.6536699c-.26359875.54698845-.54694167 1.11044598-.22897627 2.22089196-.4580461-.7760115-2.4317616-4.21271409-2.4317616-4.21271409s1.39215135-2.52075074 4.95241877-2.66078465z"
      />
      <path
        fill="#fcd900"
        d="M12.19424395 9.9932707S10.56811011 13.12520187 6.56795 12.97033643c.49425935-.85508177 2.8469039-4.9293995 2.8469039-4.9293995s.56841696-.91272352-.10213633-2.35924153c-.34107825-.50249388-.6887067-1.02805382-1.80897798-1.30816843.9012139-.00818775 4.8635232 0 4.8635232 0s1.4843688 2.46638408-.17301884 5.61974375z"
      />
      <path
        fill="#61bc5b"
        d="M1.80001293 10.01797431s-1.89960467-2.97379061.23557325-6.36108598c.4926218.85508178 2.84526634 4.9293995 2.84526634 4.9293995s.50745332.94898356 2.09400524 1.09060823c.604677-.04444778 1.23401082-.08234536 2.03804782-.91103919-.44326137.78424604-2.43185518 4.21107654-2.43185518 4.21107654s-2.87984204.0527291-4.78108426-2.9589591z"
      />
      <path
        fill="#5ab055"
        d="M6.56631245 12.99999947l.80066833-3.34116324s.87978538-.06924497 1.6178993-.87814783c-.4580461.80567455-2.41856763 4.21931107-2.41856763 4.21931107z"
      />
      <path
        fill="#ffffff"
        d="M4.30261026 7.03758671c0-1.47285917 1.19447568-2.66733485 2.66733485-2.66733485S9.63727996 5.56472754 9.63727996 7.0375867c0 1.47290595-1.19447568 2.66733485-2.66733485 2.66733485C5.49708594 9.703284 4.30261026 8.51049265 4.30261026 7.0375867z"
      />
      <path
        fill="url(#a)"
        d="M80.004 129.056c0-26.198 21.234-47.467 47.468-47.467 26.198 0 47.467 21.234 47.467 47.467 0 26.199-21.233 47.468-47.467 47.468-26.199 0-47.468-21.269-47.468-47.468z"
        transform="translate(1.0058948 .99942557) scale(.04679)"
      />
      <path
        fill="#eaca05"
        d="M12.36557846 4.3752113L9.068863 5.34230148s-.49753445-.72987938-1.56676096-.96709018c.92755505-.00495944 4.86347642 0 4.86347642 0z"
      />
      <path
        fill="#df3a32"
        d="M4.39983394 7.75263457c-.46300554-.80235266-2.36752286-4.0907868-2.36752286-4.0907868l2.44163369 2.41524574s-.25045157.51568786-.15650299 1.253755l.08234537.42178606z"
      />
    </svg>
  );
};

export const BrowserFireFox: React.FC<IconProps> = ({
  className = "",
  size = 24,
}) => {
  return (
    <svg
      width={size}
      height={size}
      className={className}
      viewBox="0 0 32 32"
      fill="none"
    >
      <path
        d="M28.9905 10.7265C28.3816 9.2574 27.1473 7.67139 26.1784 7.17039C26.967 8.72015 27.4232 10.2746 27.5976 11.4344C27.5976 11.4344 27.5976 11.4426 27.6005 11.4578C26.0156 7.49777 23.3277 5.90065 21.1327 2.42407C21.0213 2.24869 20.9105 2.07331 20.802 1.88566C20.7407 1.77985 20.6911 1.68397 20.648 1.59336C20.557 1.41757 20.4867 1.23179 20.4386 1.03975C20.439 1.03063 20.4359 1.02169 20.4301 1.01467C20.4243 1.00765 20.4161 1.00305 20.4071 1.00175C20.3985 0.999416 20.3894 0.999416 20.3808 1.00175C20.3785 1.00281 20.3763 1.00419 20.3744 1.00584C20.3709 1.00584 20.3674 1.00994 20.3639 1.0111L20.3697 1.0035C16.8483 3.07063 15.6536 6.89446 15.544 8.80784C14.1368 8.90428 12.7913 9.42358 11.683 10.298C11.5672 10.1998 11.4461 10.1081 11.3202 10.0232C11.0008 8.9027 10.9873 7.71683 11.2811 6.58931C9.84091 7.24697 8.72095 8.28463 7.90664 9.20303H7.90023C7.34433 8.49742 7.38341 6.17015 7.41491 5.68435C7.40849 5.65395 7.00076 5.89656 6.94826 5.93339C6.45773 6.2841 5.9992 6.67771 5.57805 7.1096C5.0988 7.59655 4.66096 8.12276 4.26909 8.68274C3.36752 9.96323 2.72814 11.4101 2.3879 12.9398C2.38149 12.9702 2.37565 13.0017 2.36924 13.0327C2.34299 13.1561 2.24791 13.7751 2.23099 13.9096V13.9406C2.10704 14.5803 2.02984 15.2282 2 15.8791V15.951C2 23.7097 8.27646 30 16.0182 30C22.9521 30 28.7088 24.9549 29.8364 18.328C29.8597 18.1485 29.8789 17.9673 29.8999 17.786C30.1788 15.3763 29.869 12.8439 28.9905 10.7265ZM12.8327 21.7239C12.8981 21.7549 12.9599 21.7894 13.027 21.8197L13.0363 21.8256C12.9692 21.7929 12.901 21.759 12.8333 21.7239H12.8327ZM27.6017 11.4642V11.4508V11.466V11.4642Z"
        fill="url(#paint0_linear_87_7118)"
      />
      <path
        d="M28.9907 10.7265C28.3818 9.25741 27.1475 7.67141 26.1786 7.17041C26.9672 8.72017 27.4234 10.2746 27.5978 11.4344V11.4631C28.9208 15.0572 28.1998 18.7121 27.1615 20.9452C25.555 24.4002 21.6661 27.9416 15.578 27.7692C9.00581 27.5821 3.21175 22.6885 2.1297 16.2842C1.93254 15.2735 2.1297 14.7608 2.22886 13.9406C2.10812 14.5725 2.06203 14.7555 2.00195 15.8791V15.951C2.00195 23.7098 8.27842 30 16.0202 30C22.954 30 28.7108 24.9549 29.8383 18.328C29.8616 18.1485 29.8809 17.9673 29.9019 17.7861C30.179 15.3764 29.8692 12.8439 28.9907 10.7265Z"
        fill="url(#paint1_radial_87_7118)"
      />
      <path
        d="M28.9907 10.7265C28.3818 9.25741 27.1475 7.67141 26.1786 7.17041C26.9672 8.72017 27.4234 10.2746 27.5978 11.4344V11.4631C28.9208 15.0572 28.1998 18.7121 27.1615 20.9452C25.555 24.4002 21.6661 27.9416 15.578 27.7692C9.00581 27.5821 3.21175 22.6885 2.1297 16.2842C1.93254 15.2735 2.1297 14.7608 2.22886 13.9406C2.10812 14.5725 2.06203 14.7555 2.00195 15.8791V15.951C2.00195 23.7098 8.27842 30 16.0202 30C22.954 30 28.7108 24.9549 29.8383 18.328C29.8616 18.1485 29.8809 17.9673 29.9019 17.7861C30.179 15.3764 29.8692 12.8439 28.9907 10.7265Z"
        fill="url(#paint2_radial_87_7118)"
      />
      <path
        d="M22.1776 12.3773C22.2085 12.3989 22.2359 12.4205 22.2651 12.4422C21.9133 11.8161 21.4749 11.243 20.9631 10.7398C16.6058 6.37292 19.821 1.27058 20.3629 1.01102L20.3687 1.00342C16.8473 3.07054 15.6526 6.89438 15.543 8.80776C15.7063 8.79665 15.869 8.78262 16.0353 8.78262C18.6631 8.78262 20.952 10.2312 22.1776 12.3773Z"
        fill="url(#paint3_radial_87_7118)"
      />
      <path
        d="M16.0446 13.2499C16.0219 13.6006 14.7899 14.8049 14.3589 14.8049C10.3725 14.8049 9.72559 17.2216 9.72559 17.2216C9.90058 19.2572 11.3157 20.9332 13.0277 21.82C13.1059 21.8604 13.1846 21.8966 13.2611 21.9329C13.3981 21.9913 13.5358 22.0498 13.6729 22.1018C14.26 22.3094 14.8748 22.4276 15.4969 22.4526C22.4838 22.7811 23.8383 14.08 18.7955 11.5534C20.0864 11.3283 21.4269 11.8492 22.1753 12.3759C20.9503 10.2299 18.6608 8.78125 16.033 8.78125C15.8667 8.78125 15.704 8.79528 15.5406 8.80639C14.1345 8.90403 12.7903 9.4239 11.6832 10.2983C11.8973 10.4801 12.1388 10.7221 12.6468 11.2237C13.6 12.1661 16.0394 13.1359 16.0446 13.2499Z"
        fill="url(#paint4_radial_87_7118)"
      />
      <path
        d="M16.0446 13.2499C16.0219 13.6006 14.7899 14.8049 14.3589 14.8049C10.3725 14.8049 9.72559 17.2216 9.72559 17.2216C9.90058 19.2572 11.3157 20.9332 13.0277 21.82C13.1059 21.8604 13.1846 21.8966 13.2611 21.9329C13.3981 21.9913 13.5358 22.0498 13.6729 22.1018C14.26 22.3094 14.8748 22.4276 15.4969 22.4526C22.4838 22.7811 23.8383 14.08 18.7955 11.5534C20.0864 11.3283 21.4269 11.8492 22.1753 12.3759C20.9503 10.2299 18.6608 8.78125 16.033 8.78125C15.8667 8.78125 15.704 8.79528 15.5406 8.80639C14.1345 8.90403 12.7903 9.4239 11.6832 10.2983C11.8973 10.4801 12.1388 10.7221 12.6468 11.2237C13.6 12.1661 16.0394 13.1359 16.0446 13.2499Z"
        fill="url(#paint5_radial_87_7118)"
      />
      <path
        d="M11.0311 9.83093C11.1448 9.90459 11.2382 9.96656 11.3227 10.0233C11.0034 8.90275 10.9899 7.71688 11.2837 6.58936C9.84345 7.24702 8.72349 8.28468 7.90918 9.20308C7.97509 9.20132 10.0085 9.16449 11.0311 9.83093Z"
        fill="url(#paint6_radial_87_7118)"
      />
      <path
        d="M2.1297 16.284C3.21175 22.6883 9.00581 27.5819 15.5827 27.769C21.6707 27.9414 25.5574 24.4 27.1661 20.945C28.2044 18.7113 28.9254 15.057 27.6025 11.4629V11.436C27.6025 11.4395 27.6025 11.4442 27.6054 11.4594C28.1024 14.7138 26.451 17.8665 23.8692 19.9986C23.8666 20.0045 23.8641 20.0106 23.8617 20.0167C18.8306 24.1223 14.0165 22.4936 13.0418 21.8289C12.9741 21.7962 12.9059 21.7623 12.8382 21.7272C9.9047 20.3242 8.69316 17.6438 8.95273 15.3469C6.47656 15.3469 5.63192 13.2529 5.63192 13.2529C5.63192 13.2529 7.85552 11.664 10.7861 13.046C13.5003 14.3262 16.0493 13.2535 16.0493 13.2529C16.0441 13.1389 13.6047 12.1662 12.6533 11.2267C12.1452 10.7251 11.9037 10.4831 11.6896 10.3013C11.5738 10.2031 11.4527 10.1114 11.3268 10.0265C11.2434 9.96809 11.1518 9.90963 11.0352 9.83421C10.0126 9.16778 7.97918 9.20461 7.9121 9.20636H7.90568C7.34978 8.50076 7.38886 6.17348 7.42036 5.68769C7.41395 5.65729 7.00621 5.89989 6.95371 5.93672C6.46318 6.28743 6.00465 6.68104 5.58351 7.11293C5.10426 7.59988 4.66642 8.12609 4.27455 8.68607C3.37298 9.96657 2.7336 11.4134 2.39336 12.9431C2.38228 12.97 1.88354 15.1523 2.1297 16.284Z"
        fill="url(#paint7_radial_87_7118)"
      />
      <path
        d="M20.9634 10.7399C21.4752 11.2431 21.9135 11.8162 22.2653 12.4423C22.3383 12.4971 22.4083 12.5557 22.4753 12.6176C25.6532 15.55 23.9908 19.7012 23.8642 19.9993C26.446 17.8673 28.0973 14.7146 27.6003 11.4601C26.0155 7.49777 23.3276 5.90065 21.1325 2.42407C21.0211 2.24869 20.9103 2.07331 20.8018 1.88566C20.7406 1.77985 20.691 1.68397 20.6478 1.59336C20.5569 1.41757 20.4866 1.23179 20.4384 1.03975C20.4388 1.03063 20.4358 1.02169 20.43 1.01467C20.4241 1.00765 20.4159 1.00305 20.4069 1.00175C20.3983 0.999416 20.3893 0.999416 20.3807 1.00175C20.3783 1.00281 20.3762 1.00419 20.3742 1.00584C20.3707 1.00584 20.3672 1.00994 20.3637 1.0111C19.8213 1.27066 16.606 6.37301 20.9634 10.7399Z"
        fill="url(#paint8_radial_87_7118)"
      />
      <path
        d="M22.4743 12.6146C22.4073 12.5526 22.3372 12.4941 22.2643 12.4392C22.2357 12.4176 22.206 12.396 22.1768 12.3743C21.4284 11.8482 20.088 11.3267 18.7971 11.5518C23.8393 14.0784 22.4854 22.7795 15.4985 22.451C14.8764 22.426 14.2616 22.3078 13.6744 22.1002C13.5374 22.0488 13.3997 21.9921 13.2626 21.9313C13.1833 21.895 13.1045 21.8588 13.0293 21.8185L13.0386 21.8243C14.0133 22.4908 18.8274 24.1194 23.8585 20.0121C23.8585 20.0121 23.8614 20.0045 23.8661 19.9939C23.9909 19.7011 25.6534 15.5499 22.4743 12.6146Z"
        fill="url(#paint9_radial_87_7118)"
      />
      <path
        d="M9.72532 17.2215C9.72532 17.2215 10.3722 14.8048 14.3586 14.8048C14.7897 14.8048 16.0216 13.5994 16.0444 13.2498C16.0671 12.9002 13.4953 14.3231 10.7811 13.0428C7.85055 11.6608 5.62695 13.2498 5.62695 13.2498C5.62695 13.2498 6.47159 15.3438 8.94776 15.3438C8.68819 17.6407 9.89973 20.3187 12.8332 21.7241C12.8986 21.755 12.9604 21.7895 13.0275 21.8199C11.3154 20.9349 9.90207 19.2571 9.72532 17.2215Z"
        fill="url(#paint10_radial_87_7118)"
      />
      <path
        d="M28.9905 10.7265C28.3816 9.2574 27.1473 7.67139 26.1784 7.17039C26.967 8.72015 27.4232 10.2746 27.5976 11.4344C27.5976 11.4344 27.5976 11.4426 27.6005 11.4578C26.0156 7.49777 23.3277 5.90065 21.1327 2.42407C21.0213 2.24869 20.9105 2.07331 20.802 1.88566C20.7407 1.77985 20.6911 1.68397 20.648 1.59336C20.557 1.41757 20.4867 1.23179 20.4386 1.03975C20.439 1.03063 20.4359 1.02169 20.4301 1.01467C20.4243 1.00765 20.4161 1.00305 20.4071 1.00175C20.3985 0.999416 20.3894 0.999416 20.3808 1.00175C20.3785 1.00281 20.3763 1.00419 20.3744 1.00584C20.3709 1.00584 20.3674 1.00994 20.3639 1.0111L20.3697 1.0035C16.8483 3.07063 15.6536 6.89446 15.544 8.80784C15.7073 8.79673 15.8701 8.78271 16.0363 8.78271C18.6641 8.78271 20.9531 10.2313 22.1786 12.3774C21.4302 11.8512 20.0898 11.3298 18.7989 11.5549C23.841 14.0815 22.4872 22.7826 15.5002 22.454C14.8782 22.429 14.2633 22.3108 13.6762 22.1033C13.5391 22.0518 13.4015 21.9951 13.2644 21.9343C13.1851 21.8981 13.1063 21.8618 13.0311 21.8215L13.0404 21.8273C12.9727 21.7946 12.9045 21.7607 12.8368 21.7256C12.9021 21.7566 12.964 21.7911 13.0311 21.8215C11.3155 20.9347 9.90216 19.2569 9.72542 17.2213C9.72542 17.2213 10.3723 14.8046 14.3587 14.8046C14.7898 14.8046 16.0217 13.5992 16.0445 13.2496C16.0392 13.1356 13.5998 12.1628 12.6484 11.2234C12.1403 10.7218 11.8988 10.4798 11.6848 10.298C11.5689 10.1998 11.4478 10.1081 11.3219 10.0232C11.0026 8.9027 10.9891 7.71683 11.2829 6.58931C9.84266 7.24697 8.7227 8.28463 7.90839 9.20303H7.90198C7.34608 8.49742 7.38516 6.17015 7.41666 5.68435C7.41024 5.65395 7.00251 5.89656 6.95001 5.93339C6.45948 6.2841 6.00095 6.67771 5.5798 7.1096C5.10055 7.59655 4.66271 8.12276 4.27084 8.68274C3.36927 9.96323 2.72989 11.4101 2.38965 12.9398C2.38324 12.9702 2.3774 13.0017 2.37099 13.0327C2.34474 13.1561 2.22574 13.7839 2.20941 13.9184C2.20941 13.9289 2.20941 13.9084 2.20941 13.9184C2.10019 14.5671 2.03026 15.2219 2 15.8791V15.951C2 23.7097 8.27646 30 16.0182 30C22.9521 30 28.7088 24.9549 29.8364 18.328C29.8597 18.1485 29.8789 17.9673 29.8999 17.786C30.1788 15.3763 29.869 12.8439 28.9905 10.7265ZM27.5999 11.4479V11.4631V11.4479Z"
        fill="url(#paint11_linear_87_7118)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_87_7118"
          x1="27.135"
          y1="5.49261"
          x2="3.81392"
          y2="27.9437"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.05" stopColor="#FFF44F" />
          <stop offset="0.11" stopColor="#FFE847" />
          <stop offset="0.22" stopColor="#FFC830" />
          <stop offset="0.37" stopColor="#FF980E" />
          <stop offset="0.4" stopColor="#FF8B16" />
          <stop offset="0.46" stopColor="#FF672A" />
          <stop offset="0.53" stopColor="#FF3647" />
          <stop offset="0.7" stopColor="#E31587" />
        </linearGradient>
        <radialGradient
          id="paint1_radial_87_7118"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(26.0596 4.21879) scale(29.2246 29.2888)"
        >
          <stop offset="0.13" stopColor="#FFBD4F" />
          <stop offset="0.19" stopColor="#FFAC31" />
          <stop offset="0.25" stopColor="#FF9D17" />
          <stop offset="0.28" stopColor="#FF980E" />
          <stop offset="0.4" stopColor="#FF563B" />
          <stop offset="0.47" stopColor="#FF3750" />
          <stop offset="0.71" stopColor="#F5156C" />
          <stop offset="0.78" stopColor="#EB0878" />
          <stop offset="0.86" stopColor="#E50080" />
        </radialGradient>
        <radialGradient
          id="paint2_radial_87_7118"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(15.3809 16.1925) scale(29.2246 29.2888)"
        >
          <stop offset="0.3" stopColor="#960E18" />
          <stop offset="0.35" stopColor="#B11927" stopOpacity="0.74" />
          <stop offset="0.43" stopColor="#DB293D" stopOpacity="0.34" />
          <stop offset="0.5" stopColor="#F5334B" stopOpacity="0.09" />
          <stop offset="0.53" stopColor="#FF3750" stopOpacity="0" />
        </radialGradient>
        <radialGradient
          id="paint3_radial_87_7118"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(18.904 -2.42815) scale(21.172 21.2184)"
        >
          <stop offset="0.13" stopColor="#FFF44F" />
          <stop offset="0.25" stopColor="#FFDC3E" />
          <stop offset="0.51" stopColor="#FF9D12" />
          <stop offset="0.53" stopColor="#FF980E" />
        </radialGradient>
        <radialGradient
          id="paint4_radial_87_7118"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(12.1487 23.8433) scale(13.915 13.9455)"
        >
          <stop offset="0.35" stopColor="#3A8EE6" />
          <stop offset="0.47" stopColor="#5C79F0" />
          <stop offset="0.67" stopColor="#9059FF" />
          <stop offset="1" stopColor="#C139E6" />
        </radialGradient>
        <radialGradient
          id="paint5_radial_87_7118"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(15.8005 12.7119) rotate(-13.9265) scale(7.37316 8.67852)"
        >
          <stop offset="0.21" stopColor="#9059FF" stopOpacity="0" />
          <stop offset="0.28" stopColor="#8C4FF3" stopOpacity="0.06" />
          <stop offset="0.75" stopColor="#7716A8" stopOpacity="0.45" />
          <stop offset="0.97" stopColor="#6E008B" stopOpacity="0.6" />
        </radialGradient>
        <radialGradient
          id="paint6_radial_87_7118"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(15.011 3.02041) scale(10.0108 10.0328)"
        >
          <stop stopColor="#FFE226" />
          <stop offset="0.12" stopColor="#FFDB27" />
          <stop offset="0.3" stopColor="#FFC82A" />
          <stop offset="0.5" stopColor="#FFA930" />
          <stop offset="0.73" stopColor="#FF7E37" />
          <stop offset="0.79" stopColor="#FF7139" />
        </radialGradient>
        <radialGradient
          id="paint7_radial_87_7118"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(22.8805 -3.34313) scale(42.7109 42.8046)"
        >
          <stop offset="0.11" stopColor="#FFF44F" />
          <stop offset="0.46" stopColor="#FF980E" />
          <stop offset="0.62" stopColor="#FF5634" />
          <stop offset="0.72" stopColor="#FF3647" />
          <stop offset="0.9" stopColor="#E31587" />
        </radialGradient>
        <radialGradient
          id="paint8_radial_87_7118"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(18.7517 1.33374) rotate(84.2447) scale(31.1996 20.4543)"
        >
          <stop stopColor="#FFF44F" />
          <stop offset="0.06" stopColor="#FFE847" />
          <stop offset="0.17" stopColor="#FFC830" />
          <stop offset="0.3" stopColor="#FF980E" />
          <stop offset="0.36" stopColor="#FF8B16" />
          <stop offset="0.45" stopColor="#FF672A" />
          <stop offset="0.57" stopColor="#FF3647" />
          <stop offset="0.74" stopColor="#E31587" />
        </radialGradient>
        <radialGradient
          id="paint9_radial_87_7118"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(14.7757 6.73593) scale(26.6644 26.723)"
        >
          <stop offset="0.14" stopColor="#FFF44F" />
          <stop offset="0.48" stopColor="#FF980E" />
          <stop offset="0.59" stopColor="#FF5634" />
          <stop offset="0.66" stopColor="#FF3647" />
          <stop offset="0.9" stopColor="#E31587" />
        </radialGradient>
        <radialGradient
          id="paint10_radial_87_7118"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(21.8145 8.30059) scale(29.1844 29.2484)"
        >
          <stop offset="0.09" stopColor="#FFF44F" />
          <stop offset="0.23" stopColor="#FFE141" />
          <stop offset="0.51" stopColor="#FFAF1E" />
          <stop offset="0.63" stopColor="#FF980E" />
        </radialGradient>
        <linearGradient
          id="paint11_linear_87_7118"
          x1="26.855"
          y1="5.37218"
          x2="7.01043"
          y2="25.1739"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.17" stopColor="#FFF44F" stopOpacity="0.8" />
          <stop offset="0.27" stopColor="#FFF44F" stopOpacity="0.63" />
          <stop offset="0.49" stopColor="#FFF44F" stopOpacity="0.22" />
          <stop offset="0.6" stopColor="#FFF44F" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const BrowserSafari: React.FC<IconProps> = ({
  className = "",
  size = 24,
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      className={className}
    >
      <path
        d="M16 30C23.732 30 30 23.732 30 16C30 8.26801 23.732 2 16 2C8.26801 2 2 8.26801 2 16C2 23.732 8.26801 30 16 30Z"
        fill="url(#paint0_linear_87_6961)"
      />
      <path
        d="M15.9998 28.9498C23.1519 28.9498 28.9498 23.1519 28.9498 15.9998C28.9498 8.84772 23.1519 3.0498 15.9998 3.0498C8.84772 3.0498 3.0498 8.84772 3.0498 15.9998C3.0498 23.1519 8.84772 28.9498 15.9998 28.9498Z"
        fill="url(#paint1_radial_87_6961)"
      />
      <path
        d="M16.0215 6.20007C15.934 6.20007 15.8574 6.13447 15.8574 6.04697V3.76101C15.8574 3.67351 15.934 3.60791 16.0215 3.60791C16.109 3.60791 16.1855 3.67351 16.1855 3.76101V6.04697C16.1746 6.13447 16.109 6.20007 16.0215 6.20007Z"
        fill="#F3F3F3"
      />
      <path
        d="M16.0217 6.21071C15.9232 6.21071 15.8467 6.13416 15.8467 6.04667V3.76073C15.8467 3.67323 15.9232 3.59668 16.0217 3.59668C16.1201 3.59668 16.1967 3.67323 16.1967 3.76073V6.04667C16.1967 6.13416 16.1092 6.21071 16.0217 6.21071ZM16.0217 3.61847C15.9451 3.61847 15.8686 3.68418 15.8686 3.76073V6.04667C15.8686 6.12321 15.9342 6.18892 16.0217 6.18892C16.0982 6.18892 16.1748 6.12321 16.1748 6.04667V3.76073C16.1639 3.68418 16.0982 3.61847 16.0217 3.61847Z"
        fill="white"
      />
      <path
        d="M17.116 4.97506C17.0285 4.96411 16.9629 4.89851 16.9629 4.81101L17.0394 3.79373C17.0503 3.70634 17.1269 3.64063 17.2144 3.65158C17.3019 3.66254 17.3675 3.72825 17.3675 3.81575L17.291 4.83291C17.28 4.92041 17.2035 4.98601 17.116 4.97517V4.97506Z"
        fill="#F3F3F3"
      />
      <path
        d="M17.1152 4.98604C17.0168 4.97509 16.9512 4.89854 16.9512 4.81104L17.0277 3.79377C17.0387 3.70639 17.1152 3.62984 17.2137 3.64068C17.312 3.65163 17.3777 3.72829 17.3777 3.81568L17.3012 4.83294C17.2902 4.93139 17.2137 4.99699 17.1152 4.98604ZM17.2137 3.66258C17.1371 3.66258 17.0605 3.71734 17.0605 3.79389L16.9839 4.81115C16.9839 4.88759 17.0387 4.9533 17.1262 4.96414C17.2027 4.96414 17.2793 4.90949 17.2793 4.83294L17.3558 3.81568C17.3558 3.73913 17.2902 3.67353 17.2136 3.66258H17.2137Z"
        fill="white"
      />
      <path
        d="M17.9354 6.39705C17.8478 6.37514 17.7932 6.2986 17.8041 6.21109L18.2525 3.96882C18.2745 3.88144 18.351 3.82668 18.4385 3.84858C18.526 3.87048 18.5806 3.94703 18.5697 4.03453L18.1213 6.2768C18.1103 6.35324 18.0228 6.408 17.9353 6.39705H17.9354Z"
        fill="#F3F3F3"
      />
      <path
        d="M17.9366 6.40759C17.838 6.38569 17.7834 6.29819 17.7944 6.21069L18.2428 3.96845C18.2647 3.88106 18.3522 3.81535 18.4505 3.83725C18.5489 3.85916 18.6037 3.94666 18.5927 4.03416L18.1443 6.2764C18.1224 6.36379 18.0349 6.41854 17.9366 6.40759ZM18.4505 3.85916C18.374 3.8482 18.2974 3.8919 18.2755 3.96856L17.8272 6.2108C17.8163 6.28724 17.8599 6.36379 17.9474 6.3858C18.024 6.39664 18.1005 6.35283 18.1224 6.27629L18.5708 4.03416C18.5818 3.94666 18.5271 3.88106 18.4505 3.85916Z"
        fill="white"
      />
      <path
        d="M19.2479 5.41239C19.2271 5.40737 19.2074 5.39829 19.1901 5.38567C19.1728 5.37306 19.1581 5.35715 19.1469 5.33886C19.1358 5.32058 19.1283 5.30027 19.125 5.2791C19.1217 5.25793 19.1226 5.23631 19.1276 5.21549L19.4011 4.2312C19.4229 4.1437 19.5104 4.09989 19.5979 4.12179C19.6854 4.1437 19.7402 4.2312 19.7183 4.3187L19.4448 5.3031C19.4229 5.39049 19.3354 5.43429 19.2479 5.41239Z"
        fill="#F3F3F3"
      />
      <path
        d="M19.248 5.42327C19.1605 5.40137 19.0949 5.30292 19.1278 5.21553L19.4012 4.23103C19.423 4.14364 19.5214 4.08888 19.6089 4.11079C19.6964 4.13269 19.762 4.23114 19.7292 4.31853L19.4558 5.30303C19.4339 5.39042 19.3464 5.44518 19.2481 5.42327H19.248ZM19.6089 4.14364C19.5324 4.12174 19.4449 4.16554 19.423 4.24209L19.1497 5.22637C19.1278 5.30292 19.1714 5.37958 19.2589 5.40137C19.3355 5.42327 19.423 5.37958 19.4449 5.30303L19.7183 4.31853C19.7292 4.24209 19.6855 4.16554 19.6089 4.14353V4.14364Z"
        fill="white"
      />
      <path
        d="M19.7845 6.95474C19.697 6.92188 19.6643 6.82343 19.697 6.74688L20.572 4.63594C20.6047 4.5594 20.7033 4.51559 20.7797 4.5594C20.8673 4.59214 20.9002 4.6907 20.8673 4.76714L19.9924 6.87808C19.9596 6.95474 19.8611 6.99843 19.7846 6.95474H19.7845Z"
        fill="#F3F3F3"
      />
      <path
        d="M19.7842 6.96591C19.7422 6.94989 19.7082 6.91786 19.6898 6.87685C19.6713 6.83583 19.6699 6.78917 19.6858 6.7471L20.5608 4.63613C20.5936 4.54863 20.6921 4.51578 20.7905 4.54863C20.8326 4.56465 20.8665 4.59667 20.885 4.63769C20.9034 4.67871 20.9049 4.72536 20.889 4.76744L20.014 6.87841C19.9702 6.96591 19.8717 7.0096 19.7842 6.96591ZM20.7796 4.57054C20.703 4.53779 20.6155 4.57054 20.5827 4.64708L19.7077 6.75805C19.6749 6.8346 19.7186 6.91115 19.7952 6.944C19.8717 6.97674 19.9592 6.944 19.9921 6.86745L20.8671 4.75649C20.889 4.69078 20.8561 4.60328 20.7796 4.57054Z"
        fill="white"
      />
      <path
        d="M21.2612 6.25462C21.1846 6.21081 21.1517 6.12331 21.1846 6.04676L21.6439 5.13904C21.6876 5.06238 21.7751 5.02953 21.8627 5.07333C21.9392 5.11714 21.972 5.20464 21.9392 5.28107L21.4798 6.18891C21.4361 6.26545 21.3486 6.29842 21.2611 6.25462H21.2612Z"
        fill="#F3F3F3"
      />
      <path
        d="M21.261 6.26565C21.1734 6.22184 21.1406 6.12339 21.1843 6.03589L21.6437 5.12816C21.6874 5.04054 21.786 5.0078 21.8734 5.0515C21.9609 5.0953 21.9937 5.19375 21.9499 5.28125L21.4906 6.18899C21.4468 6.27649 21.3484 6.30934 21.2609 6.26554L21.261 6.26565ZM21.8625 5.0734C21.7859 5.04066 21.6984 5.06245 21.6656 5.139L21.2062 6.04684C21.1735 6.11244 21.2062 6.19994 21.2718 6.24375C21.3484 6.27649 21.4359 6.2547 21.4687 6.17815L21.9281 5.2703C21.9609 5.2047 21.9281 5.11721 21.8625 5.0734Z"
        fill="white"
      />
      <path
        d="M21.4794 7.87365C21.4029 7.819 21.381 7.72055 21.4356 7.65495L22.7044 5.76268C22.7481 5.68613 22.8467 5.67518 22.9231 5.71899C22.9998 5.77363 23.0216 5.87209 22.9669 5.93768L21.6981 7.82995C21.6544 7.9065 21.556 7.92841 21.4794 7.87365Z"
        fill="#F3F3F3"
      />
      <path
        d="M21.4793 7.88417C21.4028 7.82953 21.3809 7.72013 21.4247 7.64358L22.6934 5.75136C22.748 5.67482 22.8465 5.65291 22.934 5.70767C23.0105 5.76231 23.0324 5.87171 22.9887 5.94826L21.7199 7.84048C21.6653 7.91703 21.5559 7.93882 21.4793 7.88417ZM22.923 5.72957C22.8575 5.68577 22.759 5.69672 22.7153 5.76231L21.4465 7.65453C21.4028 7.72001 21.4246 7.80763 21.4903 7.85132C21.5559 7.89512 21.6543 7.88417 21.698 7.81858L22.9668 5.93731C23.0105 5.87171 22.9887 5.77326 22.923 5.72957Z"
        fill="white"
      />
      <path
        d="M23.0764 7.46861C23.0109 7.41386 22.989 7.3154 23.0437 7.24981L23.678 6.45136C23.7326 6.38587 23.8311 6.37481 23.8967 6.42956C23.9624 6.48421 23.9842 6.58266 23.9294 6.64826L23.2952 7.44671C23.2405 7.51231 23.1421 7.52326 23.0765 7.46861H23.0764Z"
        fill="#F3F3F3"
      />
      <path
        d="M23.066 7.47962C22.9894 7.42486 22.9785 7.31545 23.0333 7.2389L23.6675 6.44054C23.7222 6.36388 23.8316 6.35292 23.9081 6.41864C23.9846 6.47328 23.9956 6.58269 23.9408 6.65924L23.3066 7.45771C23.2519 7.53426 23.1425 7.54522 23.066 7.47962ZM23.8862 6.44043C23.8207 6.38578 23.7331 6.39673 23.6785 6.46233L23.0441 7.2608C23.0004 7.3264 23.0114 7.4139 23.0768 7.46855C23.1425 7.52331 23.23 7.51236 23.2847 7.44676L23.919 6.64829C23.9629 6.58269 23.9518 6.48423 23.8863 6.44054L23.8862 6.44043Z"
        fill="white"
      />
      <path
        d="M22.9672 9.10953C22.9016 9.04394 22.9016 8.94549 22.9672 8.89073L24.5858 7.28302C24.6515 7.21742 24.7498 7.22826 24.8046 7.28302C24.8592 7.33766 24.8702 7.44706 24.8046 7.50171L23.1969 9.10953C23.1312 9.17513 23.0328 9.17513 22.9672 9.10953Z"
        fill="#F3F3F3"
      />
      <path
        d="M22.9565 9.12037C22.9249 9.08828 22.9072 9.04508 22.9072 9.00007C22.9072 8.95507 22.9249 8.91187 22.9565 8.87978L24.5752 7.27193C24.6073 7.24035 24.6505 7.22266 24.6955 7.22266C24.7406 7.22266 24.7838 7.24035 24.8159 7.27193C24.8474 7.30403 24.8651 7.34723 24.8651 7.39223C24.8651 7.43723 24.8474 7.48044 24.8159 7.51253L23.1971 9.12026C23.165 9.1518 23.1218 9.16948 23.0768 9.16948C23.0317 9.16948 22.9885 9.1518 22.9565 9.12026V9.12037ZM24.8049 7.28289C24.7503 7.22813 24.6518 7.22813 24.5972 7.28289L22.9784 8.89062C22.9236 8.94537 22.9236 9.04382 22.9784 9.09847C23.033 9.15323 23.1315 9.15323 23.1861 9.09847L24.8049 7.49074C24.8596 7.43598 24.8596 7.34848 24.8049 7.28289Z"
        fill="white"
      />
      <path
        d="M24.6081 9.0218C24.5534 8.95621 24.5534 8.85776 24.619 8.803L25.3955 8.14683C25.4611 8.09219 25.5596 8.10302 25.6143 8.16873C25.6689 8.23433 25.6689 8.33277 25.6034 8.38742L24.8269 9.0437C24.7612 9.09835 24.6627 9.08739 24.6081 9.0218Z"
        fill="#F3F3F3"
      />
      <path
        d="M24.5968 9.03273C24.5312 8.95618 24.5422 8.84678 24.6077 8.79214L25.3842 8.13584C25.4498 8.07024 25.5592 8.08119 25.6248 8.15774C25.6905 8.23429 25.6796 8.34369 25.614 8.39833L24.8374 9.05463C24.7719 9.12012 24.6624 9.10928 24.5969 9.03273H24.5968ZM25.603 8.16869C25.5483 8.10309 25.4608 8.10309 25.3953 8.14679L24.6187 8.80309C24.5641 8.85773 24.5531 8.94523 24.6077 9.01083C24.6624 9.07642 24.75 9.07642 24.8155 9.03273L25.5921 8.37643C25.6577 8.32179 25.6577 8.23429 25.603 8.16869Z"
        fill="white"
      />
      <path
        d="M24.17 10.5967C24.1153 10.5202 24.1372 10.4217 24.2138 10.3779L26.1168 9.10922C26.1933 9.06541 26.2918 9.08731 26.3355 9.15302C26.3902 9.22957 26.3683 9.32803 26.2918 9.37172L24.3888 10.6404C24.3231 10.6842 24.2246 10.6623 24.17 10.5967Z"
        fill="#F3F3F3"
      />
      <path
        d="M24.1592 10.5968C24.1046 10.5202 24.1265 10.4108 24.2031 10.3562L26.1061 9.08739C26.1827 9.03275 26.2921 9.05465 26.3467 9.14215C26.4015 9.2187 26.3795 9.3281 26.303 9.38263L24.4 10.6515C24.3233 10.7063 24.214 10.6844 24.1592 10.5969V10.5968ZM26.3248 9.16405C26.2811 9.09834 26.1936 9.07644 26.128 9.12025L24.2248 10.3889C24.1594 10.4327 24.1373 10.5202 24.1921 10.5968C24.2358 10.6624 24.3233 10.6843 24.389 10.6406L26.2921 9.37179C26.3577 9.31715 26.3686 9.22954 26.3248 9.16405Z"
        fill="white"
      />
      <path
        d="M25.7997 10.8265C25.7559 10.7498 25.7778 10.6515 25.8543 10.6077L26.7403 10.1046C26.8168 10.0608 26.9153 10.0936 26.959 10.1701C27.0028 10.2467 26.9809 10.3451 26.9043 10.3889L26.0184 10.8921C25.9418 10.9358 25.8434 10.903 25.7996 10.8264L25.7997 10.8265Z"
        fill="#F3F3F3"
      />
      <path
        d="M25.7889 10.8374C25.7451 10.7499 25.767 10.6514 25.8436 10.6077L26.7295 10.1046C26.8061 10.0608 26.9155 10.0936 26.9592 10.1701C27.003 10.2577 26.9811 10.3561 26.9046 10.3998L26.0186 10.9031C25.942 10.9468 25.8326 10.9139 25.7889 10.8374ZM26.9482 10.1811C26.9045 10.1046 26.817 10.0827 26.7515 10.1264L25.8655 10.6296C25.7999 10.6733 25.778 10.7608 25.8107 10.8264C25.8545 10.903 25.942 10.9249 26.0076 10.8812L26.8936 10.3779C26.9592 10.3452 26.9811 10.2577 26.9482 10.1811Z"
        fill="white"
      />
      <path
        d="M25.0671 12.2813C25.0344 12.1938 25.0671 12.1063 25.1546 12.0735L27.2656 11.1986C27.3421 11.1657 27.4406 11.2094 27.4733 11.2859C27.5062 11.3734 27.4733 11.4609 27.3858 11.4937L25.275 12.3687C25.1983 12.4015 25.1 12.3687 25.0671 12.2813Z"
        fill="#F3F3F3"
      />
      <path
        d="M25.0564 12.2923C25.0237 12.2049 25.0564 12.1064 25.1439 12.0626L27.2548 11.1877C27.2969 11.1718 27.3435 11.1733 27.3845 11.1917C27.4255 11.2102 27.4575 11.2441 27.4735 11.2861C27.5064 11.3736 27.4735 11.4721 27.386 11.5158L25.2752 12.3907C25.2331 12.4066 25.1865 12.4052 25.1455 12.3868C25.1045 12.3683 25.0724 12.3344 25.0564 12.2924V12.2923ZM27.4517 11.2971C27.4189 11.2205 27.3314 11.1877 27.2658 11.2096L25.1548 12.0845C25.0783 12.1173 25.0454 12.2049 25.0783 12.2814C25.111 12.358 25.1985 12.3908 25.2642 12.3689L27.3751 11.494C27.4517 11.4612 27.4846 11.3736 27.4517 11.2971Z"
        fill="white"
      />
      <path
        d="M26.6095 12.8283C26.5768 12.7406 26.6204 12.6533 26.7079 12.6204L27.6703 12.3031C27.7469 12.2704 27.8453 12.325 27.8672 12.4016C27.9 12.4891 27.8563 12.5766 27.7688 12.6094L26.8064 12.9267C26.7298 12.9594 26.6423 12.9158 26.6095 12.8281V12.8283Z"
        fill="#F3F3F3"
      />
      <path
        d="M26.5986 12.839C26.5659 12.7515 26.6096 12.6531 26.7081 12.6203L27.6704 12.3031C27.7579 12.2703 27.8564 12.325 27.8892 12.4126C27.9219 12.5 27.8783 12.5984 27.7797 12.6313L26.8174 12.9485C26.7299 12.9703 26.6315 12.9265 26.5986 12.839ZM27.8673 12.4235C27.8454 12.3469 27.7579 12.3031 27.6814 12.325L26.719 12.6422C26.6424 12.664 26.6096 12.7515 26.6315 12.8282C26.6534 12.9047 26.7409 12.9484 26.8174 12.9265L27.7798 12.6094C27.8564 12.5766 27.8892 12.5 27.8673 12.4234V12.4235Z"
        fill="white"
      />
      <path
        d="M25.625 14.1296C25.6031 14.0421 25.6577 13.9546 25.7452 13.9437L27.9873 13.5062C28.0747 13.4843 28.1513 13.5499 28.1731 13.6374C28.195 13.7249 28.1404 13.8124 28.0529 13.8233L25.8108 14.2608C25.7233 14.2717 25.6358 14.2171 25.6248 14.1296H25.625Z"
        fill="#F3F3F3"
      />
      <path
        d="M25.6029 14.1296C25.581 14.0311 25.6466 13.9436 25.7341 13.9217L27.9763 13.4842C28.0638 13.4623 28.1513 13.528 28.1731 13.6265C28.195 13.7248 28.1294 13.8123 28.0419 13.8342L25.7997 14.2718C25.7123 14.2937 25.6247 14.2281 25.6029 14.1295V14.1296ZM28.1513 13.6373C28.1404 13.5608 28.0638 13.5061 27.9873 13.5171L25.745 13.9546C25.6685 13.9655 25.6138 14.0529 25.6356 14.1296C25.6466 14.2062 25.7231 14.2608 25.7998 14.2499L28.0419 13.8123C28.1185 13.7904 28.1731 13.7139 28.1513 13.6373Z"
        fill="white"
      />
      <path
        d="M27.0248 14.9719C27.0139 14.8844 27.0685 14.8078 27.156 14.7968L28.1622 14.6765C28.2497 14.6656 28.3264 14.7312 28.3372 14.8187C28.3482 14.9063 28.2935 14.9828 28.206 14.9938L27.1997 15.114C27.1232 15.125 27.0357 15.0594 27.0247 14.9719H27.0248Z"
        fill="#F3F3F3"
      />
      <path
        d="M27.0139 14.9721C27.0029 14.8737 27.0685 14.7862 27.156 14.7752L28.1622 14.655C28.2497 14.644 28.3372 14.7096 28.3481 14.8081C28.3591 14.9065 28.2935 14.994 28.206 15.005L27.1997 15.1252C27.1123 15.1362 27.0247 15.0706 27.0139 14.9721ZM28.3372 14.819C28.3263 14.7425 28.2498 14.6768 28.1731 14.6877L27.167 14.8081C27.0904 14.819 27.0357 14.8956 27.0466 14.9721C27.0576 15.0487 27.1341 15.1144 27.2107 15.1034L28.2169 14.9831C28.2935 14.9721 28.3481 14.8956 28.3373 14.819H28.3372Z"
        fill="white"
      />
      <path
        d="M25.8008 16.0327C25.8008 15.9452 25.8663 15.8687 25.9539 15.8687H28.2398C28.3273 15.8687 28.3929 15.9452 28.3929 16.0327C28.3929 16.1202 28.3273 16.1967 28.2398 16.1967H25.9539C25.8664 16.1967 25.8008 16.1202 25.8008 16.0327Z"
        fill="#F3F3F3"
      />
      <path
        d="M25.7891 16.0329C25.7891 15.9345 25.8656 15.8579 25.9531 15.8579H28.2391C28.3266 15.8579 28.4031 15.9345 28.4031 16.0329C28.4031 16.1313 28.3266 16.2079 28.2391 16.2079H25.9531C25.8656 16.2079 25.7891 16.1313 25.7891 16.0329ZM28.3812 16.0439C28.3812 15.9673 28.3156 15.8908 28.2389 15.8908H25.9532C25.8767 15.8908 25.811 15.9562 25.811 16.0439C25.811 16.1204 25.8767 16.1969 25.9532 16.1969H28.2392C28.3157 16.186 28.3813 16.1204 28.3813 16.0439H28.3812Z"
        fill="white"
      />
      <path
        d="M27.0138 17.1375C27.0246 17.05 27.0903 16.9844 27.1778 16.9844L28.195 17.0609C28.2824 17.0719 28.348 17.1484 28.3371 17.2359C28.3262 17.3234 28.2605 17.389 28.173 17.389L27.1559 17.3125C27.0794 17.3015 27.0137 17.225 27.0137 17.1375H27.0138Z"
        fill="#F3F3F3"
      />
      <path
        d="M27.0029 17.1377C27.0139 17.0392 27.0904 16.9736 27.1779 16.9736L28.1953 17.0502C28.2827 17.0611 28.3593 17.1377 28.3483 17.2361C28.3375 17.3346 28.2608 17.4002 28.1733 17.4002L27.156 17.3236C27.0685 17.3127 27.0029 17.2252 27.0029 17.1377ZM28.3375 17.2361C28.3483 17.1596 28.2827 17.083 28.2061 17.083L27.1888 17.0065C27.1123 17.0065 27.0466 17.0611 27.0357 17.1487C27.0248 17.2252 27.0904 17.3017 27.167 17.3017L28.1843 17.3783C28.2608 17.3783 28.3265 17.3128 28.3375 17.2361Z"
        fill="white"
      />
      <path
        d="M25.603 17.9358C25.6249 17.8483 25.7014 17.7936 25.7889 17.8046L28.0311 18.2531C28.1186 18.2749 28.1733 18.3514 28.1514 18.4389C28.1295 18.5264 28.053 18.5812 27.9655 18.5702L25.7232 18.1218C25.6467 18.1108 25.592 18.0233 25.603 17.9358Z"
        fill="#F3F3F3"
      />
      <path
        d="M25.5922 17.9361C25.6141 17.8376 25.7016 17.783 25.7891 17.7938L28.0314 18.2424C28.1189 18.2641 28.1845 18.3516 28.1626 18.4501C28.1408 18.5485 28.0533 18.6033 27.9658 18.5923L25.7234 18.1439C25.6359 18.122 25.5813 18.0345 25.5922 17.9362V17.9361ZM28.1408 18.4501C28.1518 18.3735 28.1081 18.297 28.0314 18.2751L25.789 17.8267C25.7126 17.8159 25.6359 17.8595 25.614 17.947C25.6032 18.0236 25.6469 18.1001 25.7235 18.122L27.9658 18.5704C28.0533 18.5814 28.1189 18.5266 28.1408 18.4501Z"
        fill="white"
      />
      <path
        d="M26.5877 19.2484C26.5927 19.2275 26.6018 19.2079 26.6144 19.1906C26.627 19.1733 26.6429 19.1586 26.6612 19.1475C26.6794 19.1363 26.6997 19.1288 26.7209 19.1255C26.7421 19.1222 26.7637 19.1231 26.7845 19.1281L27.7689 19.4015C27.8564 19.4234 27.9001 19.511 27.8783 19.5984C27.8733 19.6192 27.8642 19.6389 27.8516 19.6562C27.839 19.6735 27.8231 19.6882 27.8048 19.6994C27.7865 19.7106 27.7662 19.718 27.745 19.7214C27.7238 19.7247 27.7022 19.7238 27.6814 19.7187L26.697 19.4453C26.6095 19.4234 26.5658 19.3359 26.5876 19.2484H26.5877Z"
        fill="#F3F3F3"
      />
      <path
        d="M26.577 19.2485C26.5989 19.161 26.6974 19.0954 26.7849 19.1282L27.7693 19.4015C27.8568 19.4234 27.9115 19.5219 27.8896 19.6094C27.8677 19.6969 27.7693 19.7624 27.6818 19.7297L26.6974 19.4563C26.6099 19.4344 26.5551 19.3469 26.5771 19.2486L26.577 19.2485ZM27.8568 19.6094C27.8787 19.5328 27.8349 19.4453 27.7583 19.4234L26.7739 19.15C26.6974 19.1281 26.6208 19.1719 26.5989 19.2594C26.5771 19.336 26.6208 19.4234 26.6974 19.4453L27.6818 19.7188C27.7583 19.7297 27.8349 19.686 27.8568 19.6094Z"
        fill="white"
      />
      <path
        d="M25.0457 19.7733C25.0784 19.6858 25.177 19.653 25.2534 19.6858L27.3644 20.5608C27.441 20.5935 27.4847 20.6921 27.4519 20.7685C27.4191 20.8561 27.3206 20.8889 27.2441 20.8561L25.1332 19.9812C25.0457 19.9484 25.0128 19.8499 25.0457 19.7734V19.7733Z"
        fill="#F3F3F3"
      />
      <path
        d="M25.0339 19.7627C25.05 19.7207 25.082 19.6867 25.123 19.6683C25.164 19.6498 25.2107 19.6484 25.2527 19.6643L27.3636 20.5393C27.4511 20.5722 27.4839 20.6706 27.4511 20.7691C27.4351 20.8111 27.4031 20.8451 27.3621 20.8635C27.321 20.882 27.2744 20.8834 27.2323 20.8675L25.1214 19.9925C25.0339 19.9487 25.0012 19.8502 25.0339 19.7627ZM27.4292 20.7581C27.462 20.6816 27.4292 20.5941 27.3527 20.5612L25.2418 19.6862C25.1652 19.6534 25.0887 19.6971 25.0558 19.7737C25.0231 19.8502 25.0558 19.9377 25.1324 19.9706L27.2433 20.8456C27.3198 20.8675 27.4073 20.8347 27.4292 20.7581Z"
        fill="white"
      />
      <path
        d="M25.7559 21.2499C25.7997 21.1733 25.8871 21.1405 25.9637 21.1733L26.8714 21.6328C26.9479 21.6655 26.9808 21.764 26.9371 21.8515C26.8933 21.928 26.8058 21.961 26.7293 21.928L25.8216 21.4687C25.745 21.4249 25.7121 21.3264 25.7559 21.2499Z"
        fill="#F3F3F3"
      />
      <path
        d="M25.7449 21.2389C25.7887 21.1514 25.8871 21.1186 25.9746 21.1623L26.8824 21.6218C26.9699 21.6656 27.0027 21.764 26.9589 21.8514C26.9152 21.9389 26.8167 21.9718 26.7293 21.928L25.8215 21.4687C25.7339 21.4359 25.7012 21.3264 25.7449 21.2389ZM26.9262 21.8404C26.9589 21.7639 26.937 21.6764 26.8605 21.6437L25.9527 21.1842C25.887 21.1515 25.7996 21.1842 25.7558 21.2498C25.7231 21.3264 25.7449 21.4139 25.8214 21.4467L26.7292 21.9062C26.8058 21.9389 26.8933 21.9171 26.9262 21.8404Z"
        fill="white"
      />
      <path
        d="M24.1485 21.4579C24.2033 21.3814 24.2908 21.3595 24.3673 21.4141L26.2705 22.6829C26.347 22.7266 26.358 22.8252 26.3143 22.9016C26.2595 22.9783 26.172 23.0001 26.0954 22.9454L24.1923 21.6766C24.1158 21.622 24.0939 21.5235 24.1485 21.4579Z"
        fill="#F3F3F3"
      />
      <path
        d="M24.1369 21.4471C24.1917 21.3705 24.3011 21.3486 24.3776 21.3924L26.2808 22.6611C26.3574 22.7158 26.3793 22.8142 26.3245 22.9017C26.2698 22.9784 26.1604 23.0002 26.084 22.9565L24.1807 21.6877C24.0932 21.633 24.0823 21.5236 24.1369 21.4471ZM26.2918 22.8908C26.3354 22.8253 26.3245 22.7267 26.259 22.683L24.3557 21.4142C24.2901 21.3705 24.2026 21.3924 24.1588 21.458C24.1151 21.5236 24.1261 21.6221 24.1916 21.6658L26.0948 22.9346C26.1604 22.9784 26.2479 22.9565 26.2918 22.8909V22.8908Z"
        fill="white"
      />
      <path
        d="M24.5536 23.0438C24.6082 22.9781 24.7067 22.9563 24.7723 23.0111L25.5708 23.6344C25.6364 23.6891 25.6473 23.7875 25.5927 23.8532C25.538 23.9187 25.4396 23.9407 25.3738 23.886L24.5754 23.2625C24.5099 23.2078 24.4988 23.1094 24.5536 23.0438Z"
        fill="#F3F3F3"
      />
      <path
        d="M24.542 23.0328C24.5966 22.9562 24.706 22.9453 24.7826 23.0001L25.581 23.6234C25.6575 23.6781 25.6685 23.7875 25.6137 23.864C25.5591 23.9407 25.4497 23.9515 25.3733 23.8969L24.5747 23.2734C24.4982 23.2188 24.4874 23.1093 24.542 23.0328ZM25.592 23.8532C25.6466 23.7875 25.6356 23.7 25.57 23.6453L24.7716 23.0218C24.706 22.9781 24.6185 22.9891 24.5639 23.0546C24.5091 23.1203 24.5201 23.2078 24.5857 23.2624L25.3841 23.8859C25.4497 23.9297 25.5372 23.9187 25.5918 23.8532H25.592Z"
        fill="white"
      />
      <path
        d="M22.9238 22.9345C22.9895 22.8689 23.088 22.8689 23.1426 22.9345L24.7613 24.5422C24.8271 24.6079 24.8161 24.7063 24.7613 24.761C24.6959 24.8266 24.5973 24.8266 24.5426 24.761L22.9238 23.1533C22.8692 23.0985 22.8692 22.9891 22.9238 22.9345Z"
        fill="#F3F3F3"
      />
      <path
        d="M22.9236 22.9233C22.9557 22.8917 22.999 22.874 23.044 22.874C23.089 22.874 23.1322 22.8917 23.1643 22.9233L24.7831 24.531C24.8147 24.5631 24.8324 24.6063 24.8324 24.6514C24.8324 24.6964 24.8147 24.7396 24.7831 24.7717C24.751 24.8033 24.7078 24.8209 24.6628 24.8209C24.6178 24.8209 24.5746 24.8033 24.5425 24.7717L22.9236 23.164C22.8471 23.0983 22.8471 22.989 22.9236 22.9233ZM24.7612 24.7498C24.816 24.6952 24.816 24.5967 24.7612 24.5421L23.1424 22.9343C23.0878 22.8796 22.9893 22.8796 22.9347 22.9343C22.8799 22.9889 22.8799 23.0873 22.9347 23.142L24.5534 24.7498C24.6081 24.8155 24.6957 24.8155 24.7612 24.7498Z"
        fill="white"
      />
      <path
        d="M23.0217 24.5641C23.0874 24.5095 23.1858 24.5095 23.2405 24.5751L23.9078 25.3407C23.9624 25.4064 23.9515 25.5049 23.8858 25.5595C23.8203 25.6141 23.7217 25.6141 23.6671 25.5485L22.9998 24.7829C22.9452 24.7283 22.9561 24.6298 23.0217 24.5641Z"
        fill="#F3F3F3"
      />
      <path
        d="M23.0108 24.564C23.0874 24.4986 23.1858 24.5094 23.2513 24.575L23.9185 25.3406C23.9841 25.4063 23.9732 25.5156 23.8966 25.5813C23.8201 25.6469 23.7216 25.6359 23.656 25.5703L22.9888 24.8047C22.9341 24.7282 22.9341 24.6188 23.0107 24.564H23.0108ZM23.8858 25.5594C23.9513 25.5047 23.9513 25.4171 23.9076 25.3516L23.2403 24.5859C23.1857 24.5313 23.0982 24.5203 23.0326 24.575C22.967 24.6297 22.967 24.7172 23.0107 24.7827L23.6779 25.5484C23.7326 25.614 23.8202 25.614 23.8857 25.5594H23.8858Z"
        fill="white"
      />
      <path
        d="M21.4465 24.1485C21.523 24.0939 21.6215 24.1158 21.6653 24.1923L22.934 26.0844C22.9778 26.161 22.9559 26.2594 22.8903 26.3032C22.8137 26.3579 22.7153 26.336 22.6715 26.2594L21.4027 24.3672C21.3589 24.2908 21.3808 24.1922 21.4464 24.1485H21.4465Z"
        fill="#F3F3F3"
      />
      <path
        d="M21.4467 24.1373C21.5233 24.0826 21.6327 24.1045 21.6873 24.1811L22.956 26.0732C23.0107 26.1496 22.9887 26.259 22.9014 26.3137C22.8247 26.3684 22.7154 26.3465 22.6607 26.27L21.3921 24.3779C21.3374 24.2905 21.3593 24.192 21.4467 24.1374V24.1373ZM22.8904 26.2919C22.956 26.2481 22.9779 26.1606 22.9341 26.095L21.6655 24.2029C21.6217 24.1374 21.5342 24.1263 21.4578 24.1701C21.3921 24.2138 21.3702 24.3013 21.414 24.367L22.6826 26.259C22.7264 26.3137 22.8248 26.3356 22.8903 26.2918L22.8904 26.2919Z"
        fill="white"
      />
      <path
        d="M21.2171 25.7674C21.2936 25.7237 21.3921 25.7456 21.4358 25.8221L21.939 26.7081C21.9827 26.7846 21.9498 26.8831 21.8733 26.9268C21.7967 26.9706 21.6983 26.9487 21.6546 26.8721L21.1515 25.9862C21.1187 25.9096 21.1406 25.8112 21.217 25.7675L21.2171 25.7674Z"
        fill="#F3F3F3"
      />
      <path
        d="M21.2174 25.7562C21.3049 25.7124 21.4033 25.7343 21.447 25.8109L21.9501 26.6969C21.9939 26.7735 21.972 26.8829 21.8847 26.9266C21.797 26.9704 21.6986 26.9485 21.6549 26.8719L21.1518 25.9859C21.108 25.9093 21.1299 25.8109 21.2173 25.7562H21.2174ZM21.8736 26.9157C21.9393 26.8719 21.972 26.7844 21.9283 26.7188L21.4252 25.8328C21.3814 25.7672 21.2939 25.7453 21.2283 25.778C21.1626 25.8218 21.1299 25.9093 21.1736 25.9749L21.6768 26.861C21.7095 26.9266 21.808 26.9594 21.8736 26.9156V26.9157Z"
        fill="white"
      />
      <path
        d="M19.7625 25.0454C19.85 25.0126 19.9375 25.0454 19.9704 25.1219L20.8563 27.2328C20.8891 27.3094 20.8454 27.4078 20.7688 27.4405C20.6923 27.4734 20.5938 27.4405 20.5611 27.364L19.6751 25.2532C19.6423 25.1765 19.686 25.0782 19.7625 25.0454Z"
        fill="#F3F3F3"
      />
      <path
        d="M19.7626 25.0344C19.8501 25.0017 19.9485 25.0344 19.9923 25.1219L20.8782 27.2329C20.8941 27.2749 20.8926 27.3216 20.8742 27.3626C20.8557 27.4035 20.8218 27.4356 20.7798 27.4516C20.6923 27.4844 20.5938 27.4516 20.5501 27.3641L19.6642 25.2532C19.6314 25.1766 19.6752 25.0782 19.7626 25.0344ZM20.7579 27.4298C20.8344 27.3969 20.8673 27.3094 20.8344 27.2438L19.9485 25.1329C19.9158 25.0563 19.8283 25.0235 19.7517 25.0563C19.6752 25.0891 19.6422 25.1766 19.6752 25.2423L20.561 27.3532C20.6048 27.4298 20.6813 27.4625 20.7579 27.4298Z"
        fill="white"
      />
      <path
        d="M19.2264 26.5983C19.314 26.5655 19.4014 26.6092 19.4342 26.6967L19.7515 27.6592C19.7842 27.7358 19.7296 27.8342 19.6531 27.8561C19.5656 27.8889 19.4781 27.8452 19.4453 27.7577L19.1281 26.7952C19.0953 26.7186 19.139 26.6311 19.2265 26.5983H19.2264Z"
        fill="#F3F3F3"
      />
      <path
        d="M19.2156 26.5876C19.2577 26.5717 19.3043 26.5732 19.3453 26.5916C19.3863 26.6101 19.4183 26.644 19.4343 26.686L19.7516 27.6485C19.7844 27.736 19.7297 27.8344 19.6421 27.8673C19.6 27.8831 19.5534 27.8817 19.5124 27.8632C19.4714 27.8448 19.4394 27.8108 19.4234 27.7688L19.1062 26.8064C19.0843 26.7189 19.1281 26.6204 19.2156 26.5876ZM19.6422 27.8453C19.7188 27.8235 19.7625 27.736 19.7407 27.6594L19.4234 26.697C19.4016 26.6204 19.3141 26.5876 19.2375 26.6095C19.1608 26.6314 19.1171 26.7189 19.139 26.7954L19.4562 27.7579C19.4618 27.7764 19.4712 27.7936 19.4839 27.8083C19.4965 27.823 19.5121 27.8348 19.5297 27.8431C19.5472 27.8514 19.5663 27.8558 19.5857 27.8562C19.6051 27.8566 19.6243 27.8529 19.6422 27.8454V27.8453Z"
        fill="white"
      />
      <path
        d="M17.9355 25.603C18.0229 25.5811 18.1106 25.6357 18.1214 25.7232L18.5809 27.9656C18.6028 28.0529 18.5371 28.1296 18.4495 28.1514C18.3621 28.1733 18.2745 28.1187 18.2637 28.0312L17.8041 25.7888C17.7933 25.7123 17.8479 25.6248 17.9354 25.6029L17.9355 25.603Z"
        fill="#F3F3F3"
      />
      <path
        d="M17.936 25.5921C18.0343 25.5703 18.1218 25.6359 18.1437 25.7234L18.603 27.9659C18.6249 28.0533 18.5592 28.1517 18.4717 28.1627C18.3733 28.1846 18.2858 28.119 18.264 28.0315L17.8046 25.789C17.7828 25.7015 17.8375 25.614 17.9358 25.5922L17.936 25.5921ZM18.4498 28.1408C18.5265 28.1299 18.5811 28.0533 18.5702 27.9658L18.1108 25.7234C18.1 25.6469 18.0125 25.5922 17.9358 25.614C17.8593 25.625 17.8047 25.7015 17.8156 25.789L18.275 28.0315C18.2967 28.108 18.3733 28.1517 18.4499 28.1409L18.4498 28.1408Z"
        fill="white"
      />
      <path
        d="M17.1043 27.0248C17.1918 27.0139 17.2683 27.0686 17.2902 27.1561L17.4214 28.1623C17.4324 28.2498 17.3668 28.3263 17.2791 28.3373C17.1918 28.3482 17.1152 28.2936 17.0933 28.2061L16.9621 27.1998C16.9512 27.1123 17.0168 27.0358 17.1043 27.0248Z"
        fill="#F3F3F3"
      />
      <path
        d="M17.1046 27.0139C17.2031 27.003 17.2906 27.0686 17.3015 27.1561L17.4328 28.1624C17.4438 28.2499 17.3781 28.3374 17.2796 28.3483C17.1811 28.3593 17.0936 28.2937 17.0826 28.2061L16.9514 27.1998C16.9404 27.1123 17.0061 27.0248 17.1046 27.0139ZM17.2687 28.3264C17.3453 28.3156 17.411 28.2389 17.4 28.1624L17.2687 27.1561C17.2577 27.0796 17.1811 27.0248 17.1046 27.0358C17.028 27.0467 16.9622 27.1233 16.9732 27.1998L17.1046 28.2062C17.1155 28.2827 17.1921 28.3374 17.2687 28.3264Z"
        fill="white"
      />
      <path
        d="M15.9785 25.7998C16.066 25.7998 16.1425 25.8655 16.1425 25.953V28.2389C16.1425 28.3264 16.066 28.3921 15.9785 28.3921C15.891 28.3921 15.8145 28.3264 15.8145 28.2389V25.953C15.8254 25.8655 15.891 25.7998 15.9785 25.7998Z"
        fill="#F3F3F3"
      />
      <path
        d="M15.9777 25.7891C16.0762 25.7891 16.1527 25.8656 16.1527 25.9531V28.2391C16.1527 28.3266 16.0762 28.4031 15.9777 28.4031C15.8793 28.4031 15.8027 28.3266 15.8027 28.2391V25.9532C15.8027 25.8657 15.8902 25.7891 15.9777 25.7891ZM15.9777 28.3813C16.0543 28.3813 16.1308 28.3157 16.1308 28.2391V25.9532C16.1308 25.8766 16.0652 25.811 15.9777 25.811C15.9012 25.811 15.8246 25.8766 15.8246 25.9532V28.2391C15.8355 28.3157 15.9012 28.3813 15.9777 28.3813Z"
        fill="white"
      />
      <path
        d="M14.8844 27.0251C14.9719 27.0361 15.0375 27.1017 15.0375 27.1892L14.9609 28.2064C14.9501 28.2939 14.8734 28.3595 14.7859 28.3487C14.6984 28.3376 14.6328 28.272 14.6328 28.1845L14.7094 27.1673C14.7203 27.0799 14.7969 27.0142 14.8844 27.0251Z"
        fill="#F3F3F3"
      />
      <path
        d="M14.8846 27.0139C14.983 27.0248 15.0486 27.1014 15.0486 27.1889L14.9721 28.2062C14.9611 28.2937 14.8846 28.3702 14.7861 28.3593C14.6878 28.3483 14.6221 28.2718 14.6221 28.1843L14.6986 27.167C14.7096 27.0686 14.7861 27.003 14.8846 27.0139ZM14.7861 28.3374C14.8627 28.3374 14.9393 28.2827 14.9393 28.2062L15.0159 27.1889C15.0159 27.1123 14.9611 27.0467 14.8736 27.0358C14.7971 27.0358 14.7205 27.0904 14.7205 27.1671L14.644 28.1843C14.644 28.2608 14.7096 28.3265 14.7862 28.3374H14.7861Z"
        fill="white"
      />
      <path
        d="M14.0635 25.603C14.151 25.6248 14.2056 25.7013 14.1947 25.7888L13.7463 28.0313C13.7244 28.1188 13.6478 28.1735 13.5603 28.1515C13.4728 28.1297 13.4182 28.0532 13.4291 27.9656L13.8776 25.7232C13.8885 25.6467 13.976 25.592 14.0635 25.603Z"
        fill="#F3F3F3"
      />
      <path
        d="M14.0639 25.5921C14.1623 25.614 14.217 25.7016 14.2061 25.789L13.7576 28.0314C13.7357 28.1189 13.6482 28.1845 13.5499 28.1626C13.4514 28.1407 13.3967 28.0532 13.4076 27.9657L13.8561 25.7234C13.878 25.6359 13.9655 25.5812 14.0638 25.5922L14.0639 25.5921ZM13.5499 28.1407C13.6264 28.1516 13.703 28.1079 13.7249 28.0314L14.1732 25.789C14.1842 25.7125 14.1405 25.6359 14.053 25.614C13.9764 25.6032 13.8999 25.6469 13.878 25.7235L13.4295 27.9657C13.4186 28.0532 13.4732 28.1189 13.5499 28.1407Z"
        fill="white"
      />
      <path
        d="M12.7522 26.5876C12.8398 26.6095 12.8944 26.697 12.8725 26.7845L12.5991 27.7688C12.5773 27.8562 12.4898 27.8999 12.4023 27.8781C12.3814 27.8731 12.3618 27.8641 12.3445 27.8515C12.3271 27.8388 12.3125 27.8229 12.3013 27.8047C12.2901 27.7864 12.2826 27.7661 12.2793 27.7449C12.276 27.7237 12.2769 27.7021 12.2819 27.6813L12.5554 26.697C12.5773 26.6095 12.6648 26.5658 12.7523 26.5876H12.7522Z"
        fill="#F3F3F3"
      />
      <path
        d="M12.7515 26.5767C12.8391 26.5985 12.9047 26.697 12.8718 26.7845L12.5984 27.7688C12.5766 27.8563 12.4781 27.9111 12.3906 27.8891C12.3031 27.8673 12.2375 27.7688 12.2703 27.6813L12.5437 26.697C12.5656 26.6095 12.6531 26.5547 12.7515 26.5766V26.5767ZM12.3906 27.8563C12.4672 27.8782 12.5547 27.8344 12.5766 27.7579L12.8499 26.7735C12.8718 26.697 12.8281 26.6204 12.7406 26.5985C12.6641 26.5766 12.5766 26.6204 12.5547 26.697L12.2812 27.6813C12.2703 27.7579 12.314 27.8344 12.3906 27.8563Z"
        fill="white"
      />
      <path
        d="M12.2159 25.0452C12.3034 25.078 12.3362 25.1764 12.3034 25.253L11.4285 27.3639C11.3957 27.4406 11.2972 27.4843 11.2207 27.4406C11.1441 27.3968 11.1003 27.3093 11.1331 27.2328L12.0081 25.1218C12.0408 25.0452 12.1394 25.0014 12.2158 25.0452H12.2159Z"
        fill="#F3F3F3"
      />
      <path
        d="M12.2153 25.0342C12.2573 25.0502 12.2913 25.0823 12.3098 25.1233C12.3282 25.1643 12.3296 25.211 12.3138 25.253L11.4387 27.3638C11.4059 27.4513 11.3074 27.4842 11.209 27.4513C11.167 27.4353 11.133 27.4033 11.1146 27.3623C11.0961 27.3213 11.0947 27.2747 11.1105 27.2327L11.9855 25.1217C12.0294 25.0342 12.1278 24.9905 12.2153 25.0342ZM11.2199 27.4296C11.2965 27.4623 11.384 27.4296 11.4168 27.353L12.2919 25.2421C12.3246 25.1655 12.2809 25.0889 12.2044 25.0561C12.1278 25.0234 12.0403 25.0561 12.0074 25.1327L11.1324 27.2436C11.1105 27.3092 11.1434 27.3967 11.2199 27.4296Z"
        fill="white"
      />
      <path
        d="M10.7397 25.7457C10.8162 25.7894 10.849 25.8769 10.8162 25.9534L10.3568 26.8611C10.313 26.9376 10.2255 26.9705 10.138 26.9267C10.0615 26.883 10.0287 26.7955 10.0615 26.719L10.521 25.8114C10.5647 25.7347 10.6522 25.7019 10.7397 25.7457Z"
        fill="#F3F3F3"
      />
      <path
        d="M10.7396 25.7346C10.8271 25.7783 10.8599 25.8768 10.8162 25.9642L10.3568 26.872C10.313 26.9595 10.2145 26.9924 10.1271 26.9486C10.0396 26.9049 10.0068 26.8063 10.0506 26.7189L10.5099 25.8113C10.5537 25.7236 10.6521 25.6909 10.7396 25.7346ZM10.1381 26.9268C10.2146 26.9595 10.3021 26.9376 10.3349 26.8611L10.7943 25.9534C10.827 25.8877 10.7943 25.8002 10.7287 25.7565C10.6521 25.7238 10.5646 25.7456 10.5318 25.8221L10.0724 26.7298C10.0396 26.7955 10.0724 26.883 10.1381 26.9267V26.9268Z"
        fill="white"
      />
      <path
        d="M10.5198 24.1267C10.5963 24.1813 10.6182 24.2798 10.5636 24.3454L9.29479 26.2378C9.2511 26.3142 9.15253 26.3252 9.0761 26.2815C8.99955 26.2267 8.97765 26.1284 9.03229 26.0626L10.3011 24.1702C10.3448 24.0938 10.4432 24.0719 10.5198 24.1265V24.1267Z"
        fill="#F3F3F3"
      />
      <path
        d="M10.52 24.1158C10.5965 24.1705 10.6184 24.28 10.5746 24.3565L9.3059 26.2488C9.25125 26.3252 9.15279 26.3471 9.06529 26.2925C8.98874 26.2377 8.96684 26.1284 9.01053 26.0518L10.2794 24.1596C10.334 24.083 10.4434 24.0611 10.52 24.1158ZM9.07624 26.2706C9.14173 26.3143 9.2403 26.3033 9.28399 26.2378L10.5528 24.3455C10.5965 24.28 10.5747 24.1925 10.509 24.1486C10.4434 24.1049 10.345 24.1159 10.3013 24.1814L9.03244 26.0627C8.98874 26.1284 9.01053 26.2268 9.07624 26.2705V26.2706Z"
        fill="white"
      />
      <path
        d="M8.92307 24.5311C8.98878 24.5858 9.01057 24.6842 8.95593 24.7498L8.32154 25.5482C8.26689 25.6138 8.16844 25.6248 8.10285 25.5701C8.03725 25.5155 8.01535 25.417 8.0701 25.3513L8.70438 24.5529C8.75903 24.4874 8.85748 24.4764 8.92307 24.5311Z"
        fill="#F3F3F3"
      />
      <path
        d="M8.93452 24.5202C9.01107 24.5748 9.02203 24.6842 8.96727 24.7608L8.33297 25.5592C8.27832 25.6358 8.16892 25.6467 8.09237 25.5811C8.01582 25.5264 8.00486 25.4171 8.05962 25.3404L8.69392 24.5421C8.74857 24.4654 8.85797 24.4546 8.93452 24.5202ZM8.11427 25.5592C8.17975 25.6139 8.26737 25.6031 8.32201 25.5373L8.95643 24.7389C9.00023 24.6734 8.98917 24.5858 8.92368 24.5311C8.85797 24.4763 8.77047 24.4873 8.71583 24.553L8.08141 25.3514C8.03772 25.4171 8.04867 25.5154 8.11416 25.5592H8.11427Z"
        fill="white"
      />
      <path
        d="M9.03301 22.8906C9.09861 22.9561 9.09861 23.0546 9.03301 23.1093L7.41437 24.717C7.34866 24.7827 7.25033 24.7718 7.19557 24.717C7.14093 24.6624 7.12998 24.553 7.19557 24.4983L8.80326 22.8906C8.86897 22.8249 8.96742 22.8249 9.03301 22.8906Z"
        fill="#F3F3F3"
      />
      <path
        d="M9.04327 22.8798C9.07478 22.9119 9.09244 22.9551 9.09244 23C9.09244 23.045 9.07478 23.0882 9.04327 23.1203L7.42452 24.7283C7.39243 24.7598 7.34925 24.7775 7.30428 24.7775C7.25931 24.7775 7.21613 24.7598 7.18404 24.7283C7.15246 24.6962 7.13477 24.653 7.13477 24.6079C7.13477 24.5629 7.15246 24.5197 7.18404 24.4876L8.80268 22.8798C8.83478 22.8482 8.87798 22.8306 8.92298 22.8306C8.96798 22.8306 9.01118 22.8482 9.04327 22.8798ZM7.19488 24.7172C7.24952 24.7719 7.34797 24.7719 7.40262 24.7172L9.02137 23.1093C9.07613 23.0547 9.07613 22.9562 9.02137 22.9016C8.96673 22.8468 8.86828 22.8468 8.81364 22.9016L7.19488 24.5094C7.14024 24.564 7.14024 24.6516 7.19488 24.7171V24.7172Z"
        fill="white"
      />
      <path
        d="M7.39172 22.9784C7.44636 23.0438 7.44636 23.1424 7.38077 23.1971L6.60422 23.8534C6.53862 23.9081 6.44017 23.8971 6.38541 23.8315C6.33077 23.7658 6.33077 23.6675 6.39636 23.6127L7.17291 22.9565C7.23862 22.9017 7.33696 22.9126 7.39172 22.9784Z"
        fill="#F3F3F3"
      />
      <path
        d="M7.40332 22.9672C7.46891 23.0438 7.45796 23.1531 7.39236 23.2079L6.61581 23.864C6.55021 23.9297 6.44081 23.9188 6.37521 23.8422C6.3095 23.7656 6.32045 23.6563 6.38605 23.6015L7.16272 22.9454C7.2282 22.8798 7.33772 22.8908 7.4032 22.9673L7.40332 22.9672ZM6.397 23.8313C6.45176 23.8969 6.53926 23.8969 6.60475 23.8532L7.38141 23.1969C7.43606 23.1423 7.44701 23.0547 7.39236 22.9892C7.33761 22.9235 7.25011 22.9235 7.18462 22.9673L6.40796 23.6235C6.34236 23.6781 6.34236 23.7657 6.397 23.8312V23.8313Z"
        fill="white"
      />
      <path
        d="M7.82979 21.4029C7.88444 21.4795 7.86254 21.5779 7.78599 21.6217L5.8829 22.8904C5.80636 22.9341 5.70791 22.9122 5.66421 22.8466C5.60945 22.7701 5.63136 22.6716 5.70791 22.6278L7.6111 21.3592C7.67681 21.3155 7.77515 21.3373 7.82991 21.4029H7.82979Z"
        fill="#F3F3F3"
      />
      <path
        d="M7.84089 21.4033C7.89554 21.4799 7.87364 21.5892 7.79709 21.644L5.89403 22.9126C5.81748 22.9674 5.70808 22.9454 5.65344 22.858C5.59868 22.7815 5.6207 22.6721 5.69713 22.6174L7.6003 21.3486C7.67685 21.294 7.78614 21.3159 7.84078 21.4033H7.84089ZM5.67534 22.8361C5.71904 22.9017 5.80653 22.9236 5.87213 22.8799L7.77519 21.6111C7.84089 21.5674 7.86268 21.4799 7.80804 21.4034C7.76435 21.3377 7.67685 21.3159 7.61114 21.3596L5.70808 22.6284C5.64249 22.683 5.63154 22.7705 5.67534 22.8361Z"
        fill="white"
      />
      <path
        d="M6.20019 21.1736C6.244 21.2501 6.2221 21.3486 6.14555 21.3924L5.25958 21.8954C5.18303 21.9391 5.08458 21.9064 5.04089 21.8298C4.99708 21.7533 5.01898 21.6549 5.09553 21.611L5.9815 21.108C6.05804 21.0642 6.1565 21.0971 6.2003 21.1736H6.20019Z"
        fill="#F3F3F3"
      />
      <path
        d="M6.21123 21.1624C6.25492 21.2499 6.23302 21.3483 6.15647 21.3921L5.27053 21.8951C5.19398 21.9388 5.08458 21.9061 5.04089 21.8296C4.99708 21.7421 5.01898 21.6436 5.09553 21.5998L5.98147 21.0968C6.05802 21.053 6.16742 21.0858 6.21111 21.1624H6.21123ZM5.05172 21.8186C5.09553 21.8951 5.18303 21.917 5.24862 21.8732L6.13457 21.3702C6.20016 21.3264 6.22206 21.2389 6.18932 21.1733C6.14552 21.0968 6.05802 21.0749 5.99242 21.1187L5.10648 21.6217C5.04089 21.6545 5.01898 21.7421 5.05184 21.8186H5.05172Z"
        fill="white"
      />
      <path
        d="M6.93236 19.7186C6.96511 19.8061 6.93236 19.8936 6.84486 19.9263L4.73391 20.8014C4.65736 20.8342 4.55891 20.7905 4.52617 20.7139C4.49332 20.6264 4.52617 20.5389 4.61367 20.5061L6.72462 19.6311C6.80117 19.5984 6.89962 19.6311 6.93236 19.7186Z"
        fill="#F3F3F3"
      />
      <path
        d="M6.94332 19.708C6.97606 19.7955 6.94332 19.894 6.85582 19.9376L4.74486 20.8126C4.7028 20.8285 4.65617 20.827 4.61518 20.8086C4.5742 20.7901 4.54219 20.7562 4.52617 20.7142C4.49332 20.6267 4.52617 20.5282 4.61367 20.4845L6.72462 19.6096C6.76668 19.5937 6.81331 19.5952 6.8543 19.6136C6.89529 19.6321 6.9273 19.666 6.94332 19.708ZM4.54796 20.7032C4.58082 20.7799 4.66832 20.8128 4.73391 20.7907L6.84486 19.9157C6.92141 19.883 6.95427 19.7955 6.92141 19.719C6.88867 19.6424 6.80117 19.6096 6.73546 19.6315L4.62451 20.5065C4.54796 20.5392 4.51522 20.6267 4.54796 20.7034V20.7032Z"
        fill="white"
      />
      <path
        d="M5.3908 19.1718C5.42354 19.2593 5.37985 19.3468 5.29234 19.3796L4.32984 19.6968C4.25329 19.7295 4.15484 19.6749 4.13293 19.5984C4.10019 19.5109 4.14389 19.4234 4.23139 19.3906L5.19389 19.0734C5.27044 19.0406 5.35794 19.0843 5.3908 19.1718Z"
        fill="#F3F3F3"
      />
      <path
        d="M5.40093 19.1609C5.43379 19.2484 5.39009 19.3468 5.29164 19.3797L4.32915 19.6969C4.24166 19.7296 4.1432 19.675 4.11035 19.5875C4.07761 19.4999 4.1213 19.4015 4.21987 19.3687L5.18224 19.0514C5.26974 19.0296 5.36819 19.0733 5.40104 19.161L5.40093 19.1609ZM4.13237 19.5766C4.15427 19.6532 4.24177 19.697 4.31832 19.6751L5.2808 19.3578C5.35735 19.336 5.39021 19.2485 5.3683 19.1719C5.3464 19.0954 5.2589 19.0516 5.18235 19.0735L4.21987 19.3908C4.14332 19.4235 4.11046 19.5001 4.13237 19.5766Z"
        fill="white"
      />
      <path
        d="M6.37554 17.8705C6.39733 17.958 6.34268 18.0455 6.25518 18.0564L4.01294 18.4939C3.92544 18.5158 3.84889 18.4501 3.8271 18.3626C3.8052 18.2751 3.85984 18.1876 3.94734 18.1766L6.18959 17.7392C6.27709 17.7283 6.36459 17.783 6.37543 17.8705H6.37554Z"
        fill="#F3F3F3"
      />
      <path
        d="M6.39676 17.8705C6.41866 17.9689 6.35307 18.0564 6.26557 18.0782L4.02331 18.5157C3.93581 18.5376 3.84831 18.472 3.82652 18.3736C3.80461 18.2751 3.87021 18.1876 3.95771 18.1658L6.19997 17.7283C6.28736 17.7064 6.37497 17.772 6.39676 17.8705ZM3.84831 18.3627C3.85926 18.4392 3.93581 18.4939 4.01236 18.483L6.25461 18.0455C6.33116 18.0345 6.38581 17.947 6.36402 17.8705C6.35307 17.7939 6.27652 17.7392 6.19986 17.7501L3.95771 18.1876C3.88116 18.2095 3.82652 18.2861 3.84831 18.3626V18.3627Z"
        fill="white"
      />
      <path
        d="M4.97502 17.0283C4.98586 17.1157 4.93122 17.1923 4.84372 17.2033L3.83752 17.3236C3.74991 17.3345 3.67336 17.2689 3.66252 17.1813C3.65157 17.0939 3.70622 17.0173 3.79372 17.0062L4.80002 16.886C4.87657 16.875 4.96407 16.9406 4.97502 17.0283Z"
        fill="#F3F3F3"
      />
      <path
        d="M4.98599 17.0284C4.99683 17.1267 4.93123 17.2142 4.84373 17.2252L3.83754 17.3455C3.74993 17.3565 3.66254 17.2909 3.65159 17.1924C3.64063 17.094 3.70623 17.0065 3.79373 16.9956L4.80004 16.8752C4.88743 16.8643 4.97504 16.93 4.98588 17.0283L4.98599 17.0284ZM3.66243 17.1815C3.67338 17.258 3.75004 17.3237 3.82659 17.3127L4.83278 17.1924C4.90933 17.1815 4.96409 17.1049 4.95314 17.0284C4.94218 16.9518 4.86564 16.8862 4.78909 16.8971L3.78278 17.0175C3.70623 17.0284 3.65159 17.1049 3.66243 17.1815Z"
        fill="white"
      />
      <path
        d="M6.19944 15.9673C6.19944 16.0549 6.13396 16.1314 6.04634 16.1314H3.76052C3.67302 16.1314 3.60742 16.0549 3.60742 15.9674C3.60742 15.8799 3.67302 15.8032 3.76052 15.8032H6.04646C6.13396 15.8032 6.19966 15.8799 6.19966 15.9674L6.19944 15.9673Z"
        fill="#F3F3F3"
      />
      <path
        d="M6.21073 15.967C6.21073 16.0655 6.13407 16.142 6.04657 16.142H3.76073C3.67323 16.142 3.59668 16.0654 3.59668 15.967C3.59668 15.8686 3.67323 15.792 3.76073 15.792H6.04668C6.13418 15.792 6.21073 15.8686 6.21073 15.967ZM3.61847 15.9561C3.61847 16.0327 3.68407 16.1092 3.76073 16.1092H6.04657C6.12312 16.1092 6.18882 16.0436 6.18882 15.9561C6.18882 15.8796 6.12312 15.8029 6.04657 15.8029H3.76073C3.68418 15.8139 3.61858 15.8796 3.61858 15.9561H3.61847Z"
        fill="white"
      />
      <path
        d="M4.98589 14.8624C4.97482 14.9499 4.90922 15.0155 4.82172 15.0155L3.80445 14.9389C3.71706 14.928 3.65147 14.8514 3.66231 14.7639C3.67326 14.6764 3.73897 14.6108 3.82647 14.6108L4.84363 14.6874C4.92018 14.6983 4.98589 14.7749 4.98589 14.8624Z"
        fill="#E2E2E2"
      />
      <path
        d="M4.99667 14.8626C4.98572 14.961 4.90917 15.0266 4.82167 15.0266L3.80442 14.9501C3.71703 14.9391 3.64049 14.8626 3.65144 14.7641C3.66228 14.6658 3.73894 14.6001 3.82644 14.6001L4.84358 14.6766C4.93108 14.6876 4.99667 14.7751 4.99667 14.8626ZM3.66228 14.7641C3.65144 14.8407 3.71703 14.9174 3.79358 14.9174L4.81083 14.9939C4.88727 14.9939 4.95298 14.9391 4.96393 14.8516C4.97488 14.7751 4.90917 14.6985 4.83263 14.6985L3.81537 14.622C3.73894 14.622 3.67323 14.6876 3.66228 14.7643V14.7641Z"
        fill="white"
      />
      <path
        d="M6.39703 14.0641C6.37513 14.1516 6.29858 14.2063 6.21108 14.1954L3.96893 13.736C3.88144 13.7141 3.82668 13.6376 3.84858 13.5501C3.87048 13.4626 3.94703 13.4078 4.03453 13.4189L6.27679 13.8673C6.35334 13.8891 6.40798 13.9766 6.39703 14.0641Z"
        fill="#F3F3F3"
      />
      <path
        d="M6.40749 14.0638C6.38558 14.1623 6.29808 14.217 6.21058 14.2061L3.96845 13.7576C3.88095 13.7357 3.81536 13.6482 3.83726 13.5499C3.85905 13.4513 3.94655 13.3967 4.03405 13.4076L6.27629 13.8561C6.36379 13.878 6.41844 13.9655 6.40749 14.0638ZM3.85905 13.5498C3.8481 13.6263 3.89179 13.7029 3.96845 13.7248L6.2107 14.1732C6.28724 14.1842 6.36379 14.1405 6.38569 14.0529C6.39653 13.9763 6.35284 13.8998 6.27618 13.8779L4.03416 13.4295C3.94666 13.4186 3.88106 13.4732 3.85916 13.5498H3.85905Z"
        fill="white"
      />
      <path
        d="M5.41248 12.7518C5.40746 12.7726 5.39838 12.7922 5.38576 12.8096C5.37315 12.8269 5.35724 12.8415 5.33895 12.8527C5.32066 12.8639 5.30035 12.8713 5.27918 12.8746C5.25801 12.8779 5.2364 12.8771 5.21557 12.872L4.23116 12.5986C4.14366 12.5767 4.09996 12.4892 4.12175 12.4017C4.12677 12.3808 4.13585 12.3612 4.14847 12.3439C4.16109 12.3266 4.17699 12.3119 4.19528 12.3007C4.21357 12.2896 4.23388 12.2821 4.25505 12.2788C4.27622 12.2755 4.29783 12.2764 4.31866 12.2814L5.30307 12.5549C5.39057 12.5767 5.43427 12.6642 5.41248 12.7517V12.7518Z"
        fill="#F3F3F3"
      />
      <path
        d="M5.4238 12.7516C5.40201 12.839 5.30356 12.9047 5.21605 12.8718L4.23163 12.5984C4.14413 12.5765 4.08937 12.4781 4.11128 12.3907C4.13318 12.3031 4.23163 12.2375 4.31913 12.2703L5.30356 12.5438C5.39106 12.5657 5.44582 12.6532 5.4238 12.7515V12.7516ZM4.14413 12.3905C4.12223 12.4671 4.16603 12.5546 4.24258 12.5764L5.22701 12.8498C5.30356 12.8717 5.3801 12.8279 5.40201 12.7404C5.4238 12.6639 5.3801 12.5764 5.30356 12.5546L4.31913 12.2812C4.24258 12.2702 4.16603 12.3139 4.14413 12.3906V12.3905Z"
        fill="white"
      />
      <path
        d="M6.95441 12.2267C6.92167 12.3141 6.8231 12.3469 6.74667 12.3141L4.6356 11.4391C4.55905 11.4063 4.51536 11.3079 4.5481 11.2313C4.58096 11.1438 4.67941 11.111 4.75596 11.1438L6.86691 12.0188C6.95441 12.0516 6.98726 12.15 6.95441 12.2266V12.2267Z"
        fill="#F3F3F3"
      />
      <path
        d="M6.96586 12.2377C6.94984 12.2797 6.91782 12.3136 6.8768 12.3321C6.83578 12.3505 6.78913 12.352 6.74705 12.3361L4.63608 11.4611C4.54858 11.4284 4.51584 11.3299 4.54858 11.2315C4.5646 11.1894 4.59663 11.1555 4.63764 11.137C4.67866 11.1186 4.72532 11.1171 4.76739 11.133L6.87836 12.008C6.96586 12.0517 6.9986 12.1503 6.96586 12.2377ZM4.57049 11.2424C4.53775 11.319 4.57049 11.4065 4.64704 11.4392L6.758 12.3142C6.83455 12.3471 6.9111 12.3032 6.94395 12.2267C6.9767 12.1502 6.94395 12.0627 6.86741 12.0299L4.75644 11.1549C4.67989 11.133 4.59239 11.1659 4.57049 11.2424Z"
        fill="white"
      />
      <path
        d="M6.24379 10.7499C6.20009 10.8265 6.11259 10.8593 6.03604 10.8265L5.12819 10.3671C5.05164 10.3343 5.01879 10.2358 5.06259 10.1483C5.10629 10.0718 5.19379 10.0389 5.27033 10.0718L6.17808 10.5312C6.25474 10.5749 6.28759 10.6735 6.24379 10.7499Z"
        fill="#F3F3F3"
      />
      <path
        d="M6.25485 10.7611C6.21104 10.8486 6.11259 10.8815 6.02509 10.8377L5.11735 10.3783C5.02985 10.3346 4.997 10.2361 5.04081 10.1486C5.0845 10.0611 5.18306 10.0282 5.27045 10.0721L6.17819 10.5315C6.2658 10.5642 6.29854 10.6737 6.25485 10.7611ZM5.07355 10.1596C5.04081 10.2361 5.06271 10.3236 5.13926 10.3565L6.04699 10.8159C6.1127 10.8486 6.2002 10.8159 6.2439 10.7502C6.27664 10.6736 6.25485 10.5861 6.1783 10.5533L5.25939 10.0941C5.19379 10.0613 5.10629 10.0831 5.07344 10.1597L5.07355 10.1596Z"
        fill="white"
      />
      <path
        d="M7.85114 10.542C7.79649 10.6187 7.70899 10.6406 7.63244 10.5858L5.74014 9.32811C5.6637 9.2843 5.65275 9.18585 5.69645 9.1093C5.74025 9.03275 5.83871 9.01085 5.91526 9.06549L7.8184 10.3343C7.88399 10.3781 7.9059 10.4766 7.85114 10.542Z"
        fill="#F3F3F3"
      />
      <path
        d="M7.86214 10.5531C7.8075 10.6298 7.6981 10.6516 7.62166 10.6079L5.72942 9.33905C5.65287 9.28441 5.63097 9.18596 5.68561 9.09857C5.74037 9.02191 5.84977 9 5.92632 9.04381L7.81845 10.3125C7.90595 10.3673 7.9169 10.4766 7.86214 10.5531ZM5.70751 9.10941C5.66382 9.175 5.67477 9.27346 5.74026 9.31715L7.64345 10.5861C7.70905 10.6299 7.79655 10.608 7.84035 10.5424C7.88405 10.4767 7.8731 10.3782 7.80761 10.3345L5.9043 9.06571C5.83871 9.02191 5.75121 9.04381 5.7074 9.10941H5.70751Z"
        fill="white"
      />
      <path
        d="M7.44709 8.95617C7.39244 9.02177 7.29399 9.04367 7.22839 8.98891L6.42993 8.36559C6.36433 8.31083 6.35338 8.21239 6.40802 8.14679C6.46267 8.08119 6.56112 8.05929 6.62683 8.11405L7.42518 8.73737C7.49089 8.79213 7.50185 8.89046 7.44709 8.95617Z"
        fill="#F3F3F3"
      />
      <path
        d="M7.45756 8.96737C7.40292 9.04403 7.29352 9.05498 7.21697 9.00022L6.41854 8.37689C6.34199 8.32225 6.33104 8.21285 6.38579 8.13641C6.44044 8.05975 6.54984 8.0488 6.62627 8.10356L7.42471 8.72689C7.50137 8.78164 7.51232 8.89093 7.45756 8.96759V8.96737ZM6.40758 8.14714C6.35294 8.21273 6.36389 8.30023 6.42949 8.35488L7.22792 8.97843C7.29352 9.02212 7.38101 9.01117 7.43566 8.94558C7.49042 8.87998 7.47946 8.79248 7.41387 8.73784L6.61543 8.11428C6.54984 8.07059 6.46223 8.08154 6.4077 8.14714H6.40758Z"
        fill="white"
      />
      <path
        d="M9.07611 9.06562C9.01063 9.13133 8.91206 9.13133 8.85741 9.06562L7.22784 7.45786C7.16224 7.39227 7.17308 7.29381 7.22784 7.23905C7.29344 7.17357 7.39189 7.17357 7.44654 7.23905L9.06539 8.84692C9.13099 8.90157 9.13099 9.01097 9.07634 9.06573L9.07611 9.06562Z"
        fill="#F3F3F3"
      />
      <path
        d="M9.07664 9.0766C9.04455 9.10811 9.00137 9.12576 8.95639 9.12576C8.91142 9.12576 8.86824 9.10811 8.83615 9.0766L7.21725 7.46864C7.18567 7.43654 7.16797 7.39332 7.16797 7.34829C7.16797 7.30326 7.18567 7.26003 7.21725 7.22793C7.24934 7.19639 7.29254 7.17871 7.33754 7.17871C7.38255 7.17871 7.42575 7.19639 7.45784 7.22793L9.07664 8.83578C9.15318 8.90137 9.15318 9.01077 9.07664 9.07637V9.0766ZM7.23938 7.24984C7.18462 7.30459 7.18462 7.40304 7.23938 7.45758L8.85806 9.06542C8.91281 9.12018 9.01115 9.12018 9.0658 9.06542C9.12055 9.01077 9.12055 8.91232 9.0658 8.85768L7.44712 7.239C7.39247 7.18435 7.30486 7.18435 7.23938 7.24995V7.24984Z"
        fill="white"
      />
      <path
        d="M8.97859 7.43593C8.91299 7.49068 8.81454 7.49068 8.75978 7.42497L8.09254 6.65938C8.03801 6.59378 8.04884 6.49533 8.11455 6.44068C8.18004 6.38593 8.2786 6.38593 8.33324 6.45152L9.00049 7.21723C9.05513 7.27188 9.04418 7.37033 8.97859 7.43593Z"
        fill="#F3F3F3"
      />
      <path
        d="M8.989 7.43581C8.91245 7.50141 8.814 7.49057 8.74829 7.42486L8.08115 6.65926C8.01555 6.59366 8.0265 6.48426 8.10305 6.41866C8.1796 6.35295 8.27805 6.3639 8.34365 6.42961L9.01091 7.1951C9.06555 7.27176 9.06555 7.38117 8.989 7.43581ZM8.114 6.44056C8.04829 6.49521 8.04829 6.58271 8.0921 6.64831L8.75936 7.41391C8.814 7.46867 8.9015 7.47962 8.9671 7.42486C9.0327 7.37021 9.0327 7.2826 8.989 7.21712L8.32175 6.4514C8.2671 6.38592 8.17949 6.38592 8.114 6.44056Z"
        fill="white"
      />
      <path
        d="M10.5535 7.85158C10.4769 7.90623 10.3785 7.88433 10.3347 7.80778L9.05502 5.91553C9.01122 5.83899 9.03312 5.74053 9.09871 5.69684C9.17526 5.6422 9.27371 5.6641 9.31752 5.74065L10.5862 7.63278C10.641 7.70933 10.6191 7.80778 10.5535 7.85147V7.85158Z"
        fill="#F3F3F3"
      />
      <path
        d="M10.5528 7.86264C10.4762 7.91739 10.3668 7.89538 10.3121 7.81894L9.04345 5.92667C8.98881 5.85012 9.01071 5.74083 9.09809 5.68619C9.17464 5.63143 9.28404 5.65333 9.33879 5.72988L10.6074 7.62204C10.6621 7.70954 10.6402 7.80799 10.5528 7.86264ZM9.10893 5.70798C9.04334 5.75167 9.02144 5.83917 9.06524 5.90488L10.3339 7.79704C10.3777 7.86264 10.4652 7.87359 10.5416 7.82978C10.6073 7.78609 10.6292 7.69859 10.5854 7.63299L9.31689 5.75167C9.27309 5.68619 9.17464 5.66417 9.10916 5.70798H9.10893Z"
        fill="white"
      />
      <path
        d="M10.7824 6.23295C10.7059 6.27664 10.6075 6.25485 10.5638 6.1783L10.0606 5.29235C10.0169 5.2158 10.0496 5.11735 10.1263 5.07355C10.2028 5.02985 10.3013 5.05164 10.345 5.1283L10.848 6.01414C10.8809 6.09069 10.859 6.18914 10.7826 6.23295H10.7824Z"
        fill="#F3F3F3"
      />
      <path
        d="M10.783 6.24391C10.6955 6.2876 10.597 6.26581 10.5534 6.18915L10.0501 5.30331C10.0065 5.22664 10.0284 5.11735 10.1159 5.07355C10.2034 5.02985 10.3018 5.05164 10.3455 5.1283L10.8486 6.01415C10.8924 6.0907 10.8705 6.18915 10.7831 6.24391H10.783ZM10.1268 5.0845C10.0611 5.12819 10.0284 5.21569 10.0721 5.2814L10.5753 6.16736C10.6189 6.23284 10.7064 6.25486 10.772 6.22201C10.8378 6.17831 10.8705 6.0907 10.8268 6.0251L10.3236 5.13914C10.2909 5.07366 10.1924 5.04069 10.1268 5.0845Z"
        fill="white"
      />
      <path
        d="M12.2374 6.95449C12.1501 6.98724 12.0625 6.95449 12.0297 6.87795L11.1438 4.76688C11.1111 4.69033 11.1548 4.59188 11.2313 4.55903C11.3188 4.52628 11.4063 4.55903 11.439 4.63557L12.3249 6.74653C12.3578 6.82308 12.3141 6.92153 12.2374 6.95427V6.95449Z"
        fill="#F3F3F3"
      />
      <path
        d="M12.2379 6.96583C12.1505 6.99857 12.0521 6.96583 12.0082 6.87821L11.1223 4.76739C11.1064 4.72531 11.1078 4.67866 11.1263 4.63764C11.1447 4.59663 11.1787 4.5646 11.2207 4.54858C11.3082 4.51584 11.4067 4.54858 11.4505 4.63608L12.3363 6.74702C12.3692 6.82357 12.3255 6.92202 12.238 6.96583H12.2379ZM11.2426 4.57049C11.1661 4.60323 11.1332 4.69084 11.1661 4.75644L12.0519 6.86726C12.0847 6.94381 12.1722 6.97655 12.2487 6.94381C12.3253 6.91107 12.3583 6.82346 12.3253 6.75786L11.4394 4.64692C11.3956 4.57037 11.3191 4.53752 11.2425 4.57037L11.2426 4.57049Z"
        fill="white"
      />
      <path
        d="M12.7729 5.40162C12.6854 5.43436 12.5979 5.39055 12.5652 5.30317L12.248 4.34057C12.2152 4.26402 12.2699 4.16557 12.3464 4.14378C12.4229 4.12188 12.5214 4.15473 12.5541 4.24223L12.8714 5.20472C12.9041 5.28127 12.8604 5.36876 12.7729 5.40151V5.40162Z"
        fill="#F3F3F3"
      />
      <path
        d="M12.7848 5.41263C12.7428 5.42849 12.6961 5.42703 12.6551 5.40858C12.6142 5.39012 12.5821 5.35618 12.5661 5.31418L12.2489 4.35168C12.2161 4.26418 12.2708 4.16584 12.3584 4.13299C12.4004 4.11714 12.4471 4.11859 12.4881 4.13705C12.5291 4.1555 12.5611 4.18944 12.5771 4.23144L12.8942 5.19394C12.9161 5.28144 12.8723 5.37989 12.7848 5.41263ZM12.3583 4.15489C12.2817 4.17668 12.2379 4.26418 12.2598 4.34073L12.5771 5.30334C12.5989 5.37989 12.6864 5.41263 12.763 5.39073C12.8396 5.36894 12.8833 5.28144 12.8614 5.20489L12.5442 4.24228C12.5386 4.22371 12.5292 4.20653 12.5166 4.19184C12.5039 4.17716 12.4883 4.1653 12.4708 4.15705C12.4532 4.14879 12.4341 4.14433 12.4148 4.14394C12.3954 4.14354 12.3761 4.14724 12.3583 4.15478V4.15489Z"
        fill="white"
      />
      <path
        d="M14.0636 6.39702C13.9761 6.41893 13.8886 6.36428 13.8777 6.27667L13.4183 4.03454C13.3964 3.94704 13.4621 3.87049 13.5495 3.84859C13.6371 3.82668 13.7245 3.88133 13.7354 3.96894L14.1949 6.21118C14.2058 6.28762 14.1511 6.37512 14.0636 6.39702Z"
        fill="#F3F3F3"
      />
      <path
        d="M14.0641 6.4081C13.9656 6.43 13.8781 6.36429 13.8562 6.27679L13.3968 4.03464C13.3749 3.94714 13.4406 3.84869 13.5281 3.83774C13.6266 3.81584 13.7141 3.88155 13.7359 3.96905L14.1954 6.21131C14.2172 6.29869 14.1625 6.38631 14.0641 6.4081ZM13.55 3.85964C13.4734 3.8706 13.4187 3.94714 13.4297 4.03464L13.8891 6.2769C13.9 6.35334 13.9874 6.4081 14.0641 6.38619C14.1406 6.37524 14.1953 6.29869 14.1843 6.21119L13.7249 3.96894C13.7031 3.8925 13.6266 3.84869 13.5499 3.85964H13.55Z"
        fill="white"
      />
      <path
        d="M14.8955 4.97504C14.808 4.98599 14.7314 4.93134 14.7095 4.84384L14.5783 3.83752C14.5674 3.75002 14.633 3.67347 14.7206 3.66252C14.808 3.65157 14.8845 3.70633 14.9064 3.79383L15.0376 4.80003C15.0486 4.88754 14.983 4.96409 14.8955 4.97504Z"
        fill="#F3F3F3"
      />
      <path
        d="M14.8957 4.98597C14.7972 4.99693 14.7097 4.93133 14.6988 4.84372L14.5676 3.83752C14.5566 3.75002 14.6222 3.66252 14.7207 3.65156C14.8191 3.64072 14.9066 3.70632 14.9176 3.79382L15.0488 4.80002C15.0597 4.88752 14.9941 4.97502 14.8957 4.98597ZM14.7316 3.67347C14.6551 3.68442 14.5894 3.76097 14.6003 3.83752L14.7316 4.84383C14.7426 4.92038 14.8191 4.97502 14.8957 4.96407C14.9722 4.95323 15.0379 4.87657 15.027 4.80002L14.8957 3.79382C14.8847 3.71727 14.8082 3.66252 14.7316 3.67347Z"
        fill="white"
      />
      <path
        d="M16.077 28.9391C23.229 28.9391 29.027 23.1411 29.027 15.9891C29.027 8.83697 23.229 3.03906 16.077 3.03906C8.92487 3.03906 3.12695 8.83697 3.12695 15.9891C3.12695 23.1411 8.92487 28.9391 16.077 28.9391Z"
        fill="url(#paint2_linear_87_6961)"
        fill-opacity="0.2"
      />
      <path
        d="M25.0454 7.7749L14.6001 14.4687H14.5891V14.4795L14.5782 14.4905L8.05957 25.2422L17.6408 17.5312L17.6517 17.5204V17.5094L25.0455 7.77502L25.0454 7.7749Z"
        fill="#000000"
        fill-opacity="0.05"
      />
      <path
        d="M24.8484 7.15137L14.5234 14.4904L17.5859 17.531L24.8484 7.15137Z"
        fill="#CD151E"
      />
      <path
        d="M14.5342 14.4686L16.0764 15.9888L24.8482 7.15137L14.5342 14.4686Z"
        fill="#FA5153"
      />
      <path
        d="M14.534 14.4689L17.5965 17.5093L7.27148 24.8485L14.534 14.4688V14.4689Z"
        fill="#ACACAC"
      />
      <path
        d="M7.27148 24.8485L16.0761 15.9891L14.5339 14.4688L7.27148 24.8485Z"
        fill="#EEEEEE"
      />
      <defs>
        <linearGradient
          id="paint0_linear_87_6961"
          x1="16"
          y1="30"
          x2="16"
          y2="2"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.25" stopColor="#DBDBDA" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
        <radialGradient
          id="paint1_radial_87_6961"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(17.8193 13.1552) scale(15.8073)"
        >
          <stop stopColor="#2ABCE1" />
          <stop offset="0.11363" stopColor="#2ABBE1" />
          <stop offset="1" stopColor="#3375F8" />
        </radialGradient>
        <linearGradient
          id="paint2_linear_87_6961"
          x1="15.8309"
          y1="12.2861"
          x2="9.78662"
          y2="23.1302"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopOpacity="0" />
          <stop offset="1" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const BrowserEdge: React.FC<IconProps> = ({
  className = "",
  size = 24,
}) => {
  return (
    <svg width={size} height={size} viewBox="0 0 14 14" className={className}>
      <path
        fill="#3177bc"
        d="M1.4653988 6.3265778c.3526004-2.77544 2.2447314-5.29318 5.6382665-5.32658003 2.0488113.0391 3.7347257.96736003 4.7365897 2.73760003.503993.92394.66123 1.89408.694625 2.96384v1.25762H5.0042041c.034481 3.1057802 4.5696119 3.0000302 6.5232469 1.63081v2.5280402c-1.143795.68739-3.7375091 1.29964-5.7468025.51206-1.7115172-.64286-2.9304514-2.4323-2.9221025-4.1549502-.055659-2.23471 1.110399-3.71246 2.9221025-4.55291-.3840477.47672-.676258 1.00186-.8293205 1.9091l4.252355.00001s.2487127-2.54111-2.4064211-2.54111c-2.5046593.0885-4.310797 1.54482-5.3321414 3.0362z"
      />
    </svg>
  );
};

export const IconMapPin: React.FC<IconProps> = ({
  className = "",
  size = 24,
}) => {
  return (
    <svg width={size} height={size} className={className} viewBox="0 0 24 24">
      <g transform="translate(0 -1028.4)">
        <path
          d="m12 0c-4.4183 2.3685e-15 -8 3.5817-8 8 0 1.421 0.3816 2.75 1.0312 3.906 0.1079 0.192 0.221 0.381 0.3438 0.563l6.625 11.531 6.625-11.531c0.102-0.151 0.19-0.311 0.281-0.469l0.063-0.094c0.649-1.156 1.031-2.485 1.031-3.906 0-4.4183-3.582-8-8-8zm0 4c2.209 0 4 1.7909 4 4 0 2.209-1.791 4-4 4-2.2091 0-4-1.791-4-4 0-2.2091 1.7909-4 4-4z"
          transform="translate(0 1028.4)"
          fill="#e74c3c"
        />
        <path
          d="m12 3c-2.7614 0-5 2.2386-5 5 0 2.761 2.2386 5 5 5 2.761 0 5-2.239 5-5 0-2.7614-2.239-5-5-5zm0 2c1.657 0 3 1.3431 3 3s-1.343 3-3 3-3-1.3431-3-3 1.343-3 3-3z"
          transform="translate(0 1028.4)"
          fill="#c0392b"
        />
      </g>
    </svg>
  );
};

export const DevicePhone: React.FC<IconProps> = ({
  className = "",
  size = 24,
}) => {
  return (
    <svg width={size} height={size} viewBox="0 0 64 64" className={className}>
      <path
        d="M50 4.1c0-2-2.1-4.1-4.3-4.1H18.3C16.1 0 14 2.1 14 4.1v55.7c0 2.1 2.1 4.1 4.3 4.1h27.5c2.1 0 4.3-2.1 4.3-4.1V4.1z"
        fill="#5c6d6d"
      ></path>
      <path
        d="M49 59c0 2-2 4-4 4H19c-2 0-4-2-4-4V5c0-2 2-4 4-4h26c2 0 4 2 4 4v54"
        fill="#212528"
      ></path>
      <g fill="#94989b">
        <circle cx="43.5" cy="4.5" r="1"></circle>

        <path d="M35 4.5c0 .3-.1.5-.3.5h-5.4c-.2 0-.3-.2-.3-.5c0-.2.1-.5.3-.5h5.4c.2 0 .3.3.3.5"></path>
      </g>

      <path fill="#3e4347" d="M17 8h30v48H17z"></path>

      <path
        d="M35.8 60.2c0 .4-.3.8-.8.8h-6c-.4 0-.8-.3-.8-.8v-1.5c0-.4.3-.8.8-.8h6c.4 0 .8.3.8.8v1.5"
        fill="#94989b"
      ></path>
      <path
        d="M24 14.7c0 .5-.4.8-.8.8h-3.3c-.5 0-.8-.4-.8-.8v-3.3c0-.5.4-.8.8-.8h3.3c.5 0 .8.4.8.8v3.3"
        fill="#42ade2"
      ></path>
      <path
        d="M31 14.7c0 .5-.4.8-.8.8h-3.3c-.5 0-.8-.4-.8-.8v-3.3c0-.5.4-.8.8-.8h3.3c.5 0 .8.4.8.8v3.3"
        fill="#c7e755"
      ></path>
      <path
        d="M38 14.7c0 .5-.4.8-.8.8h-3.3c-.5 0-.8-.4-.8-.8v-3.3c0-.5.4-.8.8-.8h3.3c.5 0 .8.4.8.8v3.3"
        fill="#f2b200"
      ></path>
      <path
        d="M45 14.7c0 .5-.4.8-.8.8h-3.3c-.5 0-.8-.4-.8-.8v-3.3c0-.5.4-.8.8-.8h3.3c.5 0 .8.4.8.8v3.3"
        fill="#42ade2"
      ></path>
      <path
        d="M24 53.2c0 .5-.4.8-.8.8h-3.3c-.5 0-.8-.4-.8-.8v-3.3c0-.5.4-.8.8-.8h3.3c.5 0 .8.4.8.8v3.3"
        fill="#c7e755"
      ></path>
      <path
        d="M31 53.2c0 .5-.4.8-.8.8h-3.3c-.5 0-.8-.4-.8-.8v-3.3c0-.5.4-.8.8-.8h3.3c.5 0 .8.4.8.8v3.3"
        fill="#ff435e"
      ></path>
      <path
        d="M38 53.2c0 .5-.4.8-.8.8h-3.3c-.5 0-.8-.4-.8-.8v-3.3c0-.5.4-.8.8-.8h3.3c.5 0 .8.4.8.8v3.3"
        fill="#42ade2"
      ></path>
      <path
        d="M45 53.2c0 .5-.4.8-.8.8h-3.3c-.5 0-.8-.4-.8-.8v-3.3c0-.5.4-.8.8-.8h3.3c.5 0 .8.4.8.8v3.3"
        fill="#c28fef"
      ></path>
      <path
        d="M24 33.9c0 .5-.4.8-.8.8h-3.3c-.5 0-.8-.4-.8-.8v-3.3c0-.5.4-.8.8-.8h3.3c.5 0 .8.4.8.8v3.3"
        fill="#c7e755"
      ></path>
      <path
        d="M31 33.9c0 .5-.4.8-.8.8h-3.3c-.5 0-.8-.4-.8-.8v-3.3c0-.5.4-.8.8-.8h3.3c.5 0 .8.4.8.8v3.3"
        fill="#c28fef"
      ></path>
      <path
        d="M38 33.9c0 .5-.4.8-.8.8h-3.3c-.5 0-.8-.4-.8-.8v-3.3c0-.5.4-.8.8-.8h3.3c.5 0 .8.4.8.8v3.3"
        fill="#42ade2"
      ></path>
      <path
        d="M24 27.5c0 .5-.4.8-.8.8h-3.3c-.5 0-.8-.4-.8-.8v-3.3c0-.5.4-.8.8-.8h3.3c.5 0 .8.4.8.8v3.3"
        fill="#ff435e"
      ></path>
      <path
        d="M31 27.5c0 .5-.4.8-.8.8h-3.3c-.5 0-.8-.4-.8-.8v-3.3c0-.5.4-.8.8-.8h3.3c.5 0 .8.4.8.8v3.3"
        fill="#f2b200"
      ></path>
      <path
        d="M38 27.5c0 .5-.4.8-.8.8h-3.3c-.5 0-.8-.4-.8-.8v-3.3c0-.5.4-.8.8-.8h3.3c.5 0 .8.4.8.8v3.3"
        fill="#c7e755"
      ></path>
      <path
        d="M45 27.5c0 .5-.4.8-.8.8h-3.3c-.5 0-.8-.4-.8-.8v-3.3c0-.5.4-.8.8-.8h3.3c.5 0 .8.4.8.8v3.3"
        fill="#f2b200"
      ></path>
      <path
        d="M24 21.1c0 .5-.4.8-.8.8h-3.3c-.5 0-.8-.4-.8-.8v-3.3c0-.5.4-.8.8-.8h3.3c.5 0 .8.4.8.8v3.3"
        fill="#c28fef"
      ></path>
      <path
        d="M31 21.1c0 .5-.4.8-.8.8h-3.3c-.5 0-.8-.4-.8-.8v-3.3c0-.5.4-.8.8-.8h3.3c.5 0 .8.4.8.8v3.3"
        fill="#42ade2"
      ></path>
      <path
        d="M38 21.1c0 .5-.4.8-.8.8h-3.3c-.5 0-.8-.4-.8-.8v-3.3c0-.5.4-.8.8-.8h3.3c.5 0 .8.4.8.8v3.3"
        fill="#ff435e"
      ></path>
      <path
        d="M45 21.1c0 .5-.4.8-.8.8h-3.3c-.5 0-.8-.4-.8-.8v-3.3c0-.5.4-.8.8-.8h3.3c.5 0 .8.4.8.8v3.3"
        fill="#c28fef"
      ></path>
    </svg>
  );
};

export const DeviceDesktop: React.FC<IconProps> = ({
  className = "",
  size = 24,
}) => {
  return (
    <svg width={size} height={size} viewBox="0 0 64 64" className={className}>
      <path d="M62 6c0-2-2-4-4-4H6C4 2 2 4 2 6v38h60V6z" fill="#212528"></path>
      <path d="M2 44v4c0 2 2 4 4 4h52c2 0 4-2 4-4v-4H2z" fill="#ddd"></path>
      <path
        d="M24 54c0 4-4 4-8 4h32c-4 0-8 0-8-4v-2H24v2"
        fill="#bfbebe"
      ></path>
      <path fill="#3e4347" d="M6 6h52v34H6z"></path>
      <g fill="#94989b">
        <circle cx="32" cy="47.9" r="1"></circle>
        <path d="M16 58h32v4H16z"></path>
      </g>
    </svg>
  );
};

export const DeviceTablet: React.FC<IconProps> = ({
  className = "",
  size = 24,
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 1024 1024"
      className={className}
    >
      <path
        d="M170.666667 874.666667V149.333333c0-46.933333 38.4-85.333333 85.333333-85.333333h512c46.933333 0 85.333333 38.4 85.333333 85.333333v725.333334c0 46.933333-38.4 85.333333-85.333333 85.333333H256c-46.933333 0-85.333333-38.4-85.333333-85.333333z"
        fill="#37474F"
      />
      <path
        d="M768 128H256c-12.8 0-21.333333 8.533333-21.333333 21.333333v661.333334c0 12.8 8.533333 21.333333 21.333333 21.333333h512c12.8 0 21.333333-8.533333 21.333333-21.333333V149.333333c0-12.8-8.533333-21.333333-21.333333-21.333333z"
        fill="#BBDEFB"
      />
      <path d="M448 874.666667h128v42.666666h-128z" fill="#78909C" />
    </svg>
  );
};

export const OSWindows: React.FC<IconProps> = ({
  className = "",
  size = 24,
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 -0.04 71.723 71.723"
      className={className}
    >
      <path
        d="m 501.28156,-2.1735885 29.37917,-4.038097 V 22.139534 h -29.37718 l -0.002,-24.3131225 z m 29.37917,27.9414675 v 28.030604 l -29.37551,-4.032487 -0.002,-23.996814 h 29.37719 v -0.0013 z m 3.24988,-32.4253395 39.09352,-5.3737875 V 22.139534 H 533.91061 V -6.6574605 z M 573.00416,25.767879 V 59.612757 L 533.91061,54.244251 V 25.767879 h 39.09355 z"
        fill="#00bcf2"
        transform="translate(-501.282 12.031)"
      />
    </svg>
  );
};

export const OSLinux: React.FC<IconProps> = ({ className = "", size = 24 }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      className={className}
      fill="none"
    >
      <path
        fill="#202020"
        d="M13.338 12.033c-.1-.112-.146-.319-.197-.54-.05-.22-.107-.457-.288-.61v-.001a.756.756 0 00-.223-.134c.252-.745.153-1.487-.1-2.157-.312-.823-.855-1.54-1.27-2.03-.464-.586-.918-1.142-.91-1.963.014-1.254.138-3.579-2.068-3.582-.09 0-.183.004-.28.012-2.466.198-1.812 2.803-1.849 3.675-.045.638-.174 1.14-.613 1.764-.515.613-1.24 1.604-1.584 2.637-.162.487-.24.984-.168 1.454-.023.02-.044.041-.064.063-.151.161-.263.357-.388.489-.116.116-.282.16-.464.225-.183.066-.383.162-.504.395v.001a.702.702 0 00-.077.339c0 .108.016.217.032.322.034.22.068.427.023.567-.144.395-.163.667-.061.865.102.199.31.286.547.335.473.1 1.114.075 1.619.342l.043-.082-.043.082c.54.283 1.089.383 1.526.284a.99.99 0 00.706-.552c.342-.002.717-.146 1.318-.18.408-.032.918.145 1.503.113a.806.806 0 00.068.183l.001.001c.227.455.65.662 1.1.627.45-.036.928-.301 1.315-.762l-.07-.06.07.06c.37-.448.982-.633 1.388-.878.203-.123.368-.276.38-.499.013-.222-.118-.471-.418-.805z"
      />
      <path
        fill="#F8BF11"
        d="M13.571 12.828c-.007.137-.107.24-.29.35-.368.222-1.019.414-1.434.918-.362.43-.802.665-1.19.696-.387.03-.721-.13-.919-.526v-.002c-.123-.233-.072-.6.031-.987s.251-.785.271-1.108v-.001c.02-.415.044-.776.114-1.055.07-.28.179-.468.373-.575a.876.876 0 01.027-.014c.022.359.2.725.514.804.343.09.838-.204 1.047-.445l.122-.004c.184-.005.337.006.495.143v.001c.121.102.179.296.229.512.05.217.09.453.239.621.287.32.38.534.371.672zM6.592 13.843v.003c-.034.435-.28.672-.656.758-.377.086-.888 0-1.398-.266-.565-.3-1.237-.27-1.667-.36-.216-.045-.357-.113-.421-.238-.064-.126-.066-.345.071-.72v-.001l.001-.002c.068-.209.018-.438-.015-.653-.033-.214-.049-.41.024-.546l.001-.001c.094-.181.232-.246.403-.307.17-.062.373-.11.533-.27l.001-.001h.001c.148-.157.26-.353.39-.492.11-.117.22-.195.385-.196h.005a.61.61 0 01.093.008c.22.033.411.187.596.437l.533.971v.001c.142.296.441.622.695.954.254.333.45.666.425.921z"
      />
      <path
        fill="#D6A312"
        d="M9.25 4.788c-.043-.084-.13-.164-.28-.225-.31-.133-.444-.142-.617-.254-.28-.181-.513-.244-.706-.244a.834.834 0 00-.272.047c-.236.08-.392.25-.49.342-.02.019-.044.035-.104.08-.06.043-.15.11-.28.208-.117.086-.154.2-.114.332.04.132.167.285.4.417h.001c.145.085.244.2.358.291a.801.801 0 00.189.117c.072.031.156.052.26.058.248.015.43-.06.59-.151.16-.092.296-.204.452-.255h.001c.32-.1.548-.301.62-.493a.324.324 0 00-.008-.27z"
      />
      <path
        fill="#202020"
        d="M8.438 5.26c-.255.133-.552.294-.869.294-.316 0-.566-.146-.745-.289-.09-.07-.163-.142-.218-.193-.096-.075-.084-.181-.045-.178.066.008.076.095.117.134.056.052.126.12.211.187.17.135.397.266.68.266.284 0 .614-.166.816-.28.115-.064.26-.179.379-.266.09-.067.087-.147.162-.138.075.009.02.089-.085.18-.105.092-.27.214-.403.283z"
      />
      <path
        fill="#ffffff"
        d="M12.337 10.694a1.724 1.724 0 00-.104 0h-.01c.088-.277-.106-.48-.621-.713-.534-.235-.96-.212-1.032.265-.005.025-.009.05-.011.076a.801.801 0 00-.12.054c-.252.137-.389.386-.465.692-.076.305-.098.674-.119 1.09-.013.208-.099.49-.186.79-.875.624-2.09.894-3.122.19-.07-.11-.15-.22-.233-.328a13.85 13.85 0 00-.16-.205.65.65 0 00.268-.05.34.34 0 00.186-.192c.063-.17 0-.408-.202-.68-.201-.273-.542-.58-1.043-.888-.368-.23-.574-.51-.67-.814-.097-.305-.084-.635-.01-.96.143-.625.51-1.233.743-1.614.063-.046.023.086-.236.567-.232.44-.667 1.455-.072 2.248.016-.564.15-1.14.377-1.677.329-.747 1.018-2.041 1.072-3.073.029.02.125.086.169.11.126.075.221.184.344.283a.85.85 0 00.575.2c.24 0 .427-.079.582-.168.17-.096.304-.204.433-.245.27-.085.486-.235.608-.41.21.83.7 2.027 1.014 2.611.167.31.5.969.643 1.762.091-.002.191.01.299.038.375-.973-.319-2.022-.636-2.314-.128-.124-.135-.18-.07-.177.343.304.795.917.96 1.608.075.315.09.646.01.973.04.017.08.034.12.054.603.293.826.548.719.897z"
      />
      <path
        fill="#E6E6E6"
        d="M8.04 8.062c-.556.002-1.099.251-1.558.716-.46.464-.814 1.122-1.018 1.888l.061.038v.004c.47.298.805.598 1.012.878.219.296.316.584.223.834a.513.513 0 01-.27.283l-.041.015c.074.097.146.197.213.3.944.628 2.042.396 2.867-.172.08-.278.153-.536.163-.698.021-.415.042-.792.124-1.12.082-.33.242-.63.544-.795.017-.01.034-.015.051-.023a.756.756 0 01.022-.094c-.242-.622-.591-1.14-1.01-1.5-.42-.36-.897-.551-1.382-.554zm2.37 2.155l-.002.005v-.002l.001-.004z"
      />
      <path
        fill="#ffffff"
        d="M9.278 3.833a1.05 1.05 0 01-.215.656 4.119 4.119 0 00-.218-.09l-.127-.045c.029-.035.085-.075.107-.127a.669.669 0 00.05-.243l.001-.01a.673.673 0 00-.035-.236.434.434 0 00-.108-.184.223.223 0 00-.156-.07H8.57a.228.228 0 00-.151.06.434.434 0 00-.122.175.676.676 0 00-.05.243v.01a.718.718 0 00.009.14 1.773 1.773 0 00-.354-.12 1.196 1.196 0 01-.01-.133v-.013a1.035 1.035 0 01.088-.447.793.793 0 01.25-.328.554.554 0 01.346-.123h.006c.125 0 .232.036.342.116a.78.78 0 01.257.324c.063.138.094.273.097.433l.001.012zM7.388 3.997a1.05 1.05 0 00-.277.125.623.623 0 00.002-.15v-.008a.651.651 0 00-.048-.192.37.37 0 00-.096-.141.158.158 0 00-.119-.045c-.042.004-.077.024-.11.065a.372.372 0 00-.07.156.626.626 0 00-.013.205v.008a.634.634 0 00.048.193.367.367 0 00.116.156l-.102.08-.078.056a.706.706 0 01-.16-.24c-.053-.12-.082-.24-.09-.381v-.001a1.071 1.071 0 01.045-.39.668.668 0 01.167-.292.359.359 0 01.264-.118c.084 0 .158.028.235.09a.68.68 0 01.199.271c.053.12.08.24.089.382v.001c.003.06.003.115-.002.17z"
      />
      <path
        fill="#202020"
        d="M7.806 4.335c.01.034.065.029.097.045.027.014.05.045.08.046.03.001.076-.01.08-.04.005-.038-.052-.063-.088-.077-.047-.019-.107-.028-.151-.003-.01.005-.021.018-.018.03zM7.484 4.335c-.01.034-.065.029-.096.045-.028.014-.05.045-.081.046-.03.001-.076-.01-.08-.04-.005-.038.052-.063.088-.077.047-.019.108-.028.152-.003.01.005.02.018.017.03z"
      />
    </svg>
  );
};

export const OSMac: React.FC<IconProps> = ({ className = "", size = 24 }) => {
  return (
    <svg
      fill="#000000"
      width={size}
      height={size}
      viewBox="0 0 512 512"
      className={className}
    >
      <g id="7935ec95c421cee6d86eb22ecd114eed">
        <path
          d="M248.644,123.476c-5.45-29.71,8.598-60.285,25.516-80.89
     c18.645-22.735,50.642-40.17,77.986-42.086c4.619,31.149-8.093,61.498-24.826,82.965
     C309.37,106.527,278.508,124.411,248.644,123.476z M409.034,231.131c8.461-23.606,25.223-44.845,51.227-59.175
     c-26.278-32.792-63.173-51.83-97.99-51.83c-46.065,0-65.542,21.947-97.538,21.947c-32.96,0-57.965-21.947-97.866-21.947
     c-39.127,0-80.776,23.848-107.19,64.577c-9.712,15.055-16.291,33.758-19.879,54.59c-9.956,58.439,4.916,134.557,49.279,202.144
     c21.57,32.796,50.321,69.737,87.881,70.059c33.459,0.327,42.951-21.392,88.246-21.616c45.362-0.258,53.959,21.841,87.372,21.522
     c37.571-0.317,67.906-41.199,89.476-73.991c15.359-23.532,21.167-35.418,33.11-62.023
     C414.435,352.487,389.459,285.571,409.034,231.131z"
        ></path>
      </g>
    </svg>
  );
};

export const OSUnknown: React.FC<IconProps> = ({
  className = "",
  size = 24,
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 1024 1024"
      className={className}
    >
      <path d="M537 950.3l-470-230v-482l470 212z" fill="#37BBEF" />
      <path d="M537 950.3l420-230v-480l-420 210z" fill="#2481BA" />
      <path d="M67 238.3l470 212 420-210L462.6 73.7z" fill="#3ED6FF" />
      <path
        d="M259.6 703l38.7 18v36.4l-38.7-17.9V703z m24.7-283.7c-64.5-30.5-117.2-7.8-120.8 50.4l38.8 18.2c3.6-38 39.1-52.5 82.1-32.2 45.4 21.4 82.3 73.5 82.3 116s-36.9 59.9-82.2 38.8L259.6 599v77l38.7 18v-41.2c60.2 21.5 107-4.6 107-62.8 0.1-62.7-54.1-139.1-121-170.7z"
        fill="#FFFFFF"
      />
    </svg>
  );
};
